import { printQuery } from './biz/outbound/b2b/ToBConfirPickDiscrepancies'
import { getEmployeeInfo, queryNotFinishVasListOfOutboundNo } from '@/api/biz/invop/invopService'
import getPrefix from '@/api/apiConfig.js'
const createBizTypeMapping = () => {
  // 服务模块地址, 开发环境localhost时,模块context名会自动去掉.
  var serviceUri
  if (process.env.NODE_ENV === 'production') {
    // TODO
    serviceUri = {
      loginUrl: '/tljdApi/master/loginController.ns',
      receivingService: `${getPrefix().inboundApi}/inbound/services/receivingWSSoap?wsdl`,
      bookingService: `${getPrefix().inboundApi}/inbound/services/bookingWSSoap?wsdl`,
      putawayService: `${getPrefix().inboundApi}/inbound/services/putaway?wsdl`,
      smartqueryService: `${getPrefix().reportApi}/services/smartQueryWS?wsdl`,
      smartHistoryQueryService: '/historyReportApi/services/smartQueryWS?wsdl',
      asyncExportService: `${getPrefix().asyncExportApi}/services/smartQueryWS?wsdl`,
      masterService: `${getPrefix().mcsApi}/mcs/service/simpleWebServiceSoap?wsdl`,
      powerService: `${getPrefix().mcsApi}/power/service/authoritymsWSSoap?wsdl`,
      checkstockService: `${getPrefix().invopApi}/invop/services/simpleWebServiceSoap?wsdl`,
      innerService: '/iwms5pl1Api/inner/services/checkWebServiceSoap?wsdl',
      innerWaveService: '/iwms5pl1Api/inner/services/obInternalWaveWebServiceSoap?wsdl',
      innerConfluenceService: '/iwms5pl1Api/inner/services/obInternalConfluenceWebServiceSoap?wsdl',
      innerShipWebService: '/iwms5pl1Api/inner/services/obInternalShipWebServiceSoap?wsdl',
      obInternalMiniWarehouseWebService: '/iwms5pl1Api/inner/services/obInternalMiniWarehouseWebServiceSoap?wsdl',
      outconfigWebService: '/tljdApi/inner/services/outConfigWebServiceSoap?wsdl',
      shipmentService: `${getPrefix().outboundApi}/shipment/services/check?wsdl`,
      pickingplanService: `${getPrefix().outboundApi}/pickingplan/services/taskassign_taWS?wsdl`,
      pickingService: `${getPrefix().outboundApi}/picking/services/pickingWS?wsdl`,
      innerWorkService: '/tljdApi/inner/services/obInternalWorkMonitorWebServiceSoap?wsdl',
      waveService: `${getPrefix().outboundApi}/pickingplan/services/waveWS?wsdl`,
      locationService: `${getPrefix().outboundApi}/pickingplan/services/locationWS?wsdl`,
      stockService: `${getPrefix().stockApi}/stock/services/stockQueryWebServiceSoap`,
      transferOfStoskService: `${getPrefix().invopApi}/invop/services/transSimpleWebServiceSoap?wsdl`,
      invopSuService: `${getPrefix().invopApi}/su-services/serviceWS?wsdl`,
      illService: `${getPrefix().outboundApi}/orderCenter/services/illWS?wsdl`,
      orderCenterService: `${getPrefix().outboundApi}/orderCenter/services/otmInternalWS?wsdl`,
    }
  } else if (process.env.NODE_ENV === 'pre') {
    serviceUri = {
      loginUrl: '/tljdApi/master/loginController.ns',
      receivingService: `${getPrefix().inboundApi}/inbound/services/receivingWSSoap?wsdl`,
      bookingService: `${getPrefix().inboundApi}/inbound/services/bookingWSSoap?wsdl`,
      putawayService: `${getPrefix().inboundApi}/inbound/services/putaway?wsdl`,
      smartqueryService: `${getPrefix().reportApi}/services/smartQueryWS?wsdl`,
      smartHistoryQueryService: '/historyReportApi/services/smartQueryWS?wsdl',
      asyncExportService: `${getPrefix().asyncExportApi}/services/smartQueryWS?wsdl`,
      masterService: `${getPrefix().mcsApi}/mcs/service/simpleWebServiceSoap?wsdl`,
      powerService: `${getPrefix().mcsApi}/power/service/authoritymsWSSoap?wsdl`,
      checkstockService: `${getPrefix().invopApi}/invop/services/simpleWebServiceSoap?wsdl`,
      innerService: '/iwms5pl1Api/inner/services/checkWebServiceSoap?wsdl',
      innerWaveService: '/iwms5pl1Api/inner/services/obInternalWaveWebServiceSoap?wsdl',
      innerConfluenceService: '/iwms5pl1Api/inner/services/obInternalConfluenceWebServiceSoap?wsdl',
      innerShipWebService: '/iwms5pl1Api/inner/services/obInternalShipWebServiceSoap?wsdl',
      obInternalMiniWarehouseWebService: '/iwms5pl1Api/inner/services/obInternalMiniWarehouseWebServiceSoap?wsdl',
      outconfigWebService: '/tljdApi/inner/services/outConfigWebServiceSoap?wsdl',
      shipmentService: `${getPrefix().outboundApi}/shipment/services/check?wsdl`,
      pickingplanService: `${getPrefix().outboundApi}/pickingplan/services/taskassign_taWS?wsdl`,
      pickingService: `${getPrefix().outboundApi}/picking/services/pickingWS?wsdl`,
      innerWorkService: '/tljdApi/inner/services/obInternalWorkMonitorWebServiceSoap?wsdl',
      waveService: `${getPrefix().outboundApi}/pickingplan/services/waveWS?wsdl`,
      locationService: `${getPrefix().outboundApi}/pickingplan/services/locationWS?wsdl`,
      stockService: `${getPrefix().stockApi}/stock/services/stockQueryWebServiceSoap`,
      transferOfStoskService: `${getPrefix().invopApi}/invop/services/transSimpleWebServiceSoap?wsdl`,
      invopSuService: `${getPrefix().invopApi}/su-services/serviceWS?wsdl`,
      illService: `${getPrefix().outboundApi}/orderCenter/services/illWS?wsdl`,
      orderCenterService: `${getPrefix().outboundApi}/orderCenter/services/otmInternalWS?wsdl`,
    }
  } else if (process.env.NODE_ENV === 'development') {
    // TODO: serivce 应该带 callcode 或者callcode全部删掉
    // serviceUri = {
    //   loginUrl: 'http://tl.jd.net/master/loginController.ns',
    //   receivingService: 'http://inbound.lwms.jd.com/inbound/services/receivingWSSoap?wsdl',
    //   putawayService: 'http://inbound.lwms.jd.com/inbound/services/putaway?wsdl',
    //   bookingService: `${getPrefix().inboundApi}/inbound/services/bookingWSSoap?wsdl`,
    //   smartqueryService: 'http://mcs.lwms.jd.com/smartquery/services/smartQueryWS?wsdl',
    //   masterService: 'http://mcs.lwms.jd.com/mcs/service/simpleWebServiceSoap?wsdl',
    //   powerService: 'http://mcs.lwms.jd.com/power/service/authoritymsWSSoap?wsdl',
    //   checkstockService: 'http://invop.lwms.jd.com/invop/services/simpleWebServiceSoap?wsdl',
    //   innerService: 'http://iwms5pl1.jd.com/inner/services/checkWebServiceSoap?wsdl',
    //   innerWaveService: 'http://iwms5pl1.jd.com/inner/services/obInternalWaveWebServiceSoap?wsdl',
    //   innerConfluenceService: 'http://iwms5pl1.jd.com/inner/services/obInternalConfluenceWebServiceSoap?wsdl',
    //   innerShipWebService: 'http://iwms5pl1.jd.com/inner/services/obInternalShipWebServiceSoap?wsdl',
    //   obInternalMiniWarehouseWebService: 'http://iwms5pl1.jd.com/inner/services/obInternalMiniWarehouseWebServiceSoap?wsdl',
    //   outconfigWebService: 'http://tl.jd.net/inner/services/outConfigWebServiceSoap?wsdl',
    //   shipmentService: 'http://outbound.lwms.jd.com/shipment/services/check?wsdl',
    //   pickingplanService: 'http://outbound.lwms.jd.com/pickingplan/services/taskassign_taWS?wsdl',
    //   pickingService: 'http://outbound.lwms.jd.com/picking/services/pickingWS?wsdl',
    //   innerWorkService: 'http://tl.jd.net/inner/services/obInternalWorkMonitorWebServiceSoap?wsdl',
    //   waveService: 'http://outbound.lwms.jd.com/pickingplan/services/waveWS?wsdl',
    //   locationService: 'http://outbound.lwms.jd.com/pickingplan/services/locationWS?wsdl',
    //   stockService: 'http://stock.lwms.jd.com/services/stockQueryWebServiceSoap',
    //   transferOfStoskService: 'http://invop.lwms.jd.com/invop/services/transSimpleWebServiceSoap?wsdl',
    //   illService: 'http://outbound.lwms.jd.com/orderCenter/services/illWS?wsdl',
    //   orderCenterService: 'http://outbound.lwms.jd.com/orderCenter/services/otmInternalWS?wsdl'
    // }
    serviceUri = {
      loginUrl: '/tljdApi/master/loginController.ns',
      receivingService: `${getPrefix().inboundApi}/inbound/services/receivingWSSoap?wsdl`,
      bookingService: `${getPrefix().inboundApi}/inbound/services/bookingWSSoap?wsdl`,
      putawayService: `${getPrefix().inboundApi}/inbound/services/putaway?wsdl`,
      smartqueryService: `${getPrefix().reportApi}/services/smartQueryWS?wsdl`,
      smartHistoryQueryService: '/historyReportApi/services/smartQueryWS?wsdl',
      asyncExportService: `${getPrefix().asyncExportApi}/services/smartQueryWS?wsdl`,
      masterService: `${getPrefix().mcsApi}/mcs/service/simpleWebServiceSoap?wsdl`,
      powerService: `${getPrefix().mcsApi}/power/service/authoritymsWSSoap?wsdl`,
      checkstockService: `${getPrefix().invopApi}/invop/services/simpleWebServiceSoap?wsdl`,
      innerService: '/iwms5pl1Api/inner/services/checkWebServiceSoap?wsdl',
      innerWaveService: '/iwms5pl1Api/inner/services/obInternalWaveWebServiceSoap?wsdl',
      innerConfluenceService: '/iwms5pl1Api/inner/services/obInternalConfluenceWebServiceSoap?wsdl',
      innerShipWebService: '/iwms5pl1Api/inner/services/obInternalShipWebServiceSoap?wsdl',
      obInternalMiniWarehouseWebService: '/iwms5pl1Api/inner/services/obInternalMiniWarehouseWebServiceSoap?wsdl',
      outconfigWebService: '/tljdApi/inner/services/outConfigWebServiceSoap?wsdl',
      shipmentService: `${getPrefix().outboundApi}/shipment/services/check?wsdl`,
      pickingplanService: `${getPrefix().outboundApi}/pickingplan/services/taskassign_taWS?wsdl`,
      pickingService: `${getPrefix().outboundApi}/picking/services/pickingWS?wsdl`,
      innerWorkService: '/tljdApi/inner/services/obInternalWorkMonitorWebServiceSoap?wsdl',
      waveService: `${getPrefix().outboundApi}/pickingplan/services/waveWS?wsdl`,
      locationService: `${getPrefix().outboundApi}/pickingplan/services/locationWS?wsdl`,
      stockService: `${getPrefix().stockApi}/stock/services/stockQueryWebServiceSoap`,
      transferOfStoskService: `${getPrefix().invopApi}/invop/services/transSimpleWebServiceSoap?wsdl`,
      invopSuService: `${getPrefix().invopApi}/su-services/serviceWS?wsdl`,
      illService: `${getPrefix().outboundApi}/orderCenter/services/illWS?wsdl`,
      orderCenterService: `${getPrefix().outboundApi}/orderCenter/services/otmInternalWS?wsdl`,
    }
  }

  // 开发环境服务对应端口
  var portMap = {
    inbound: ':10503',
    smartQuery: ':10901',
    mcs: ':10305',
    invop: ':10504',
    inner: ':10801',
    shipment: ':8086',
    pickingplan: ':8087',
    power: ':10505',
    stock: ':8090',
    picking: ':8089',
    orderCenter: ':8088'
  }

  const serviceParams={
    transferOfStoskService:(bizType)=>{
      return{
        uri: serviceUri.transferOfStoskService,
        arg0: `{"bizType":"${bizType}","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}`
      }
    },
    shipmentService:(bizType)=>{
      return{
        uri: serviceUri.shipmentService,
        arg0: `{"bizType":"${bizType}","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}`
      }
    },
    masterService:(bizType)=>{
      return{
        uri: serviceUri.masterService,
        arg0: `{"bizType":"${bizType}","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}`
      }
    },
    locationService:(bizType)=>{
      return{
        uri: serviceUri.locationService,
        arg0: `{"bizType":"${bizType}","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}`
      }
    },
    stockService: (bizType)=>{
      return{
        uri: serviceUri.stockService,
        arg0: `{"bizType":"${bizType}","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}`
      }
    },
    waveService: (bizType)=>{
      return{
        uri: serviceUri.waveService,
        arg0: `{"bizType":"${bizType}","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}`
      }
    }
  }

  var service = {
    host: window.location.host,
    hostname: window.location.hostname,
    port: window.location.port,
    getBizTypeUri: function (bizType) {
      return bizType['uri']
    },
    getBizTypeUrl: function (bizType) {
      return bizType['uri']
      // if (bizType.uri && bizType['uri'].includes('http://')) {
      //   return bizType['uri']
      // } else if (this.hostname.includes('localhost')) {
      //   // 刨掉模块名
      //   var uri = bizType['uri']
      //   var port = portMap[uri.split('/', 2)[1]]
      //   uri = uri.substring(uri.split('/', 2).join('/').length)
      //   return 'https://' + this.hostname + port + uri
      // } else {
      //   return 'https://' + this.host + bizType['uri']
      // }
    },
    packageData: function (bizType, data) {
      return {
        'arg0': bizType['arg0'],
        'arg1': data
      }
    },
    // uri约定格式： /模块名/services(有时是service)/服务名?wsdl
    bizTypeMap: {
      /** ****receivingService*****/
      wms_login: {
        uri: serviceUri.loginUrl
      },

      //无主包裹查询
      wms_unknown_queryUnknownPackagesList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_queryUnknownPackagesList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //新增无主包裹
      wms_unknown_addUnknownPackage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_addUnknownPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
       //修改无主包裹
       wms_unknown_updateUnknownPackageWMS: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_updateUnknownPackageWMS","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //更新无主包裹操作
      wms_receiving_getUnknownPackageOperationList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_getUnknownPackageOperationList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },


      //无主包裹操作查询
      wms_unknown_claimUnknownPackage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_claimUnknownPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //获取图片
      wms_unknown_getUnknownPackagePictures: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_getUnknownPackagePictures","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //获取详情
      wms_unknown_getUnknownPackageDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_getUnknownPackageDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //无主包裹二次认领
      wms_unknown_reclaimUnknownPackage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_reclaimUnknownPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //销毁无主包裹
      wms_unknown_destroyUnknownPackage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_destroyUnknownPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //销毁无主包裹
      wms_unknown_uploadUnknownPackageFile: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_uploadUnknownPackageFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //无主分页
      wms_unknown_queryUnknownPackagesByPage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_unknown_queryUnknownPackagesByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      /** ****receivingService*****/
      // 查询卸货明细列表
      wms_inbound_booking_selectIbBookingDUnloadingList: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_inbound_booking_selectIbBookingDUnloadingList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 运单号创建售后入库单调用FOP
      wms_receiving_scanTrackingNoForCreatingAfterSalesOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_scanTrackingNoForCreatingAfterSalesOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 扫描卸货箱号
      wms_inbound_booking_scanCartonWhenReceiving: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_inbound_booking_scanCartonWhenReceiving","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 校验是否批次完验
      wms_inbound_booking_checkBatchIsCompleted: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_inbound_booking_checkBatchIsCompleted","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 修改验收状态
      updateInboundStatusWhenStartingToReceive: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"asnOpt","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取已验收和已卸货箱数
      wms_inbound_get_received_and_unloaded_carton_numer: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_get_received_and_unloaded_carton_numer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingResult_goodsScanForPC: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_goodsScanForPC","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_executeReceiving: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_executeReceiving","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_executeContainerFinish: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_executeContainerFinish","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingSnService_querySerialList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingSnService_querySerialList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingSnService_queryBoxSerial: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingSnService_queryBoxSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 验收任务查询
      wms_receiving_receivingTask_getIbReceivingTask: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_getIbReceivingTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 打印信息查询
      wms_inbound_printGoodsTag: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_printGoodsTag","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 验收记录查询
      wms_receiving_receivingResult_getLastIbReceivingR: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_getLastIbReceivingR","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 采购单扫描商品条码，调master接口判断是否重码
      wms_receiving_qrySkuListByBarcodeAndOwnerNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_querySkuListByBarcodeForService","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取商品等级
      wms_inbound_queryProductLevelListByOwnerNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_queryProductLevelListByOwnerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取箱规
      wms_inbound_queryBoxRuleListByGoodsNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_queryBoxRuleListByGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 备件库入大库-获取验收主表
      wms_receiving_receivingTask_ibReceivingTaskMService_getIbReceivingTaskM: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_ibReceivingTaskMService_getIbReceivingTaskM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 备件库入大库-获取验收明细表
      wms_receiving_receivingTask_ibReceivingTaskDService_getIbReceivingTaskDs: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_ibReceivingTaskDService_getIbReceivingTaskDs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 大库拒收，更新验收任务状态
      wms_receiving_spareParts_rejectSpareReceivingTask: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_spareParts_rejectSpareReceivingTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 大库拒收，回传dtc
      wms_receiving_spareParts_sendMsgToDTC: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_spareParts_sendMsgToDTC","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库-入库单
      getExceptAsnWorker: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"getExceptAsnWorker","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库-入库单-20251105
      receiving_workerOverTimes_getAllWorkerOverTimes: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"receiving_workerOverTimes_getAllWorkerOverTimes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库-重置
      resetExceptAsnWorker: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"resetExceptAsnWorker","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库-验收
      receiving_workerOverTimes_getWorkerOverTimes: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"receiving_workerOverTimes_getWorkerOverTimes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库--验收重置
      receiving_workerOverTimes_resetOverTimesWorker: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"receiving_workerOverTimes_resetOverTimesWorker","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingResult_goodsCancel3: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_goodsCancel3","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架异常处理的查询
      wms_co_putaway_getExContainerInfo: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_getExContainerInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receipt_getReceiptMDByAsn: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receipt_getReceiptMDByAsn","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架异常处理 验收少货
      wms_co_putaway_rePostLess: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_rePostLess","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_ib_park_booking_releasePlatform: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_ib_park_booking_releasePlatform","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 上架异常处理 库内少货
      wms_co_putaway_lossGoods: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_lossGoods","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_add_print_barCode_record: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_addPrintRecord","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_i18n_wms5_asn_accept: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_i18n_wms5_asn_accept","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_i18n_asn_accept: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_i18n_asn_accept","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      /** ****masterService*****/
      // 从master获取SKU信息: 根据sku、ISBN、UPC、序列号查询符合条件的商品信息
      wms_masterservice_scanGoodsInfoByCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanGoodsInfoByCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_getShelflifeAsDays: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getShelflifeAsDays","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_qryGoodsKeepDaysType: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryGoodsKeepDaysType","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_qryItemBaseForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryItemBaseForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_qrySuppilerByNoForObj: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qrySuppilerByNoForObj","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_getSysConfigValue: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getSysConfigValue","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_getLotAttrListOfSku: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getLotAttrListOfSku","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_checkDupedSkuList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkDupedSkuList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_qryNameByNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryNameByNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_getSerialTracList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getSerialTracList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_querySerialTracDetailByOrderNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialTracDetailByOrderNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_querySerialTracDetailLikeOrderNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialTracDetailLikeOrderNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_getSerialTracListByCondition: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getSerialTracListByCondition","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 耗材扫描接口
      wms_masterservice_scanConsumableItem: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanConsumableItem","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 耗材测量接口
      wms_masterservice_measureConsumableItem: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"measureConsumableItem","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 商品四级扫码
      wms_masterservice_scanGoodsInfoByCode4: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanGoodsInfoByCode4","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查看老品是否体积大于阈值并且设置了机区
      checkGoodsVolumeIsOverThreshold: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkGoodsVolumeIsOverThreshold","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 箱规码信息查询
      wms_masterservice_queryBoxRuleGroupListByCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryBoxRuleGroupListByCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 新品采集箱规码信息查询
      wms_masterservice_queryBoxRuleGroupListByBoxBarcode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryBoxRuleGroupListByBoxBarcode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 箱规和sku信息查询
      wms_masterservice_queryGoodsNoByBoxRuleCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryGoodsNoByBoxRuleCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 根据箱规码查询箱规详细信息
      wms_masterservice_querySkuBoxRuleDef: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySkuBoxRuleDef","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 根据goodsNoList, boxRuleCode 查询商品箱规信息
      wms_masterservice_queryBoxRuleListByGoodsNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryBoxRuleListByGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 通过商品sku 获得所有信息
      wms_masterservice_getGoodsZoneRefInfoByGoodsNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getGoodsZoneRefInfoByGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 通过商品编码得到 商品信息
      wms_masterservice_qryItemBaseForObjToAOS: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryItemBaseForObjToAOS","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 通过商品编码得到 商品信息
      wms_masterservice_qryItemBaseForObj: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryItemBaseForObj","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_queryBoxRuleListWithBoxBarcode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryBoxRuleListWithBoxBarcode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 箱规码采集
      wms_masterservice_updateSkuBoxRule: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateSkuBoxRule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 新品采集
      wms_masterservice_saveOrUpdateItemBaseUnit: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveOrUpdateItemBaseUnit","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 查询物流属性流水信息
      wms_masterservice_queryItemBaseReport: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getItemBaseReportList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 新品批量采集
      wms_masterservice_multiSaveOrUpdateItemBaseUnit: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"multiSaveOrUpdateItemBaseUnit","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 获取master 的字段
      getGoodsAttrByColumns: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getGoodsAttrByColumns","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 获取商品的相关信息 从OMC拉取单个
      wms_masterservice_pullGoodsInfoFromOMC: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"pullGoodsInfoFromOMC","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      //  校验序列号 是否符合所有规则
      wms_masterservice_batchCheckSerialIsRightByAllRules: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchCheckSerialIsRightByAllRules","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      //  校验单个序列号
      wms_masterservice_checkSerialIsRightByAllRules: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkSerialIsRightByAllRules","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 序列号 保存前判断
      wms_masterservice_querySerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 序列号  添加  释放  新方法
      wms_masterservice_modifySerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifySerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 序列号  删除  新方法
      wms_masterservice_deleteSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 序列号  锁定  新方法
      lockSingleSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"lockSingleSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      unlockeSingleSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"unlockSingleSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      lockBatchSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"lockBatchSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      unlockBatchSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"unlockBatchSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 箱号
      querySerialByBoxNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialByBoxNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 箱号
      querySerialGoodsByBoxNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialGoodsByBoxNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //机区储位类型
      queryDistinctRobotLocTypeList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDistinctRobotLocTypeList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
       //查询机区储位
       queryRobotLocTypeConfigList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryRobotLocTypeConfigList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
       //保存机区储位
       saveRobotLocTypeConfig: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveRobotLocTypeConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //获取报表自定义
      queryUserConfig: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryUserConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //保存报表自定义
      saveUserConfig: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveUserConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryAssistantByAssistantUserAccount: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryAssistantByAssistantUserAccount","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      /** *****power*************/
      wms_authorityms_getUserMenus: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_getUserMenus","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取逻辑区类型
      wms_authorityms_master_queryLogicAreaType: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryLogicAreaType","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取逻辑区
      wms_authorityms_master_queryLogicAreaAll: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryLogicAreaAll","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 校验逻辑区是否存在
      checkLogicAreaPrecedenceIsValid: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"checkLogicAreaPrecedenceIsValid","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取未分配储区
      wms_authorityms_master_noBindingZoneOfLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_noBindingZoneOfLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 添加逻辑区
      wms_authorityms_master_addLogicAreaAndZone: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_addLogicAreaAndZone","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 获取逻辑区
      wms_authorityms_master_queryLogicAreaAndZone: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryLogicAreaAndZone","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 删除逻辑区
      wms_authorityms_master_removeLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_removeLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_authorityms_master_updateLogicAreaPriority: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_updateLogicAreaPriority","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取角色组
      wms_authorityms_master_queryRoleGroups: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryRoleGroups","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取角色
      wms_authorityms_master_queryRoles: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryRoles","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 获取用户
      wms_authorityms_master_queryUserAll: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryUserAll2","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 获取用户逻辑区
      wms_authorityms_master_queryUserLogicAreaByLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryUserLogicAreaByLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //
      wms_authorityms_master_queryBusinessTypeAll: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryBusinessTypeAll","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_authorityms_master_queryUserTaskLevelByLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_queryUserTaskLevelByLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 分配权限
      wms_authorityms_master_addUserLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_addUserLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_authorityms_master_valUserSkillLevel: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_valUserSkillLevel","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'

      },
      // 校验用户(主管)权限 - 扫描主管二维码后校验
      wms_authorityms_master_validateUserPermission: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_authorityms_master_validateUserPermission","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 根据逻辑区获取所有该逻辑区下的用户
      wms_authorityms_master_getAllUserListByLogicArea: {
        uri: serviceUri.powerService,
        arg0: '{"bizType":"wms_authorityms_master_getAllUserListByLogicArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      /** *****putaway*************/
      wms_co_putaway_getSingleTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_getSingleTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_doTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_doTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接，容器查询
      wms_receiving_container_queryReturnContainerMapByQueryBean: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_container_queryReturnContainerMapByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接，删除扫描纪录
      wms_receiving_parcel_fakeDeleteReturnParcelDetailByIds: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_fakeDeleteReturnParcelDetailByIds","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接，完成交接
      wms_receiving_parcel_finishJoin: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_finishJoin","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-包裹交接，容器查询。获取容器订单包裹信息，不带翻页
      wms_receiving_parcel_queryReturnContainerAndParcelByQueryBean: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_queryReturnContainerAndParcelByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-包裹交接，查询明细。根据容器号查询所有扫描（接收）明细
      wms_receiving_parcel_queryReturnParcelDetailByQueryBean: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_queryReturnParcelDetailByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-根据订单号或者包裹号判断是否能够扫描
      wms_receiving_parcel_queryReturnParcelByQueryBean: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_queryReturnParcelByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-根据容器号和订单号修改包裹信息
      wms_receiving_parcel_updateParcelByScanOrderNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_updateParcelByScanOrderNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-根据单个ID修改明细
      wms_receiving_parcel_updateReturnParcelDetails: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_updateReturnParcelDetails","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 退货包裹交接-查询未交接的容器信息
      wms_receiving_parcel_queryUnhandledParcelInfo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_queryUnhandledParcelInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 扫描客退单号、运单号及包裹号进行客退交接
      wms_receiving_parcel_handoverByOrderNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_handoverByOrderNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 客退单号查询
      wms_receiving_return_scanOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 客退单号查询, 如果没查到,不报错
      wms_receiving_return_scanOrder_web: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanOrder_web","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_scanContainer: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_scanCode: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_scanTrackingNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanTrackingNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_createReturnOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_createReturnOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_scanOrderTaskD: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_scanOrderTaskD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_parcel_getOrderNoFromToParcelNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_getOrderNoFromToParcelNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_return_rejectionParcelBatch: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_return_rejectionParcelBatch","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingResult_getIbReceivingRMList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_getIbReceivingRMList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_inbound_receiving_getFinishedIbReceivingRMCount: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving_getFinishedIbReceivingRMCount","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_receiving_receivingResult_canContainerConfirm: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_canContainerConfirm","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingResult_getUseIbReceivingRDList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_getUseIbReceivingRDList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_return_addByReceiving: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_return_addByReceiving","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingResult_deleteReceivingRdAndRemoveTaskDQty: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_deleteReceivingRdAndRemoveTaskDQty","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_collectSn_getGoodsSerialNoList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_collectSn_getGoodsSerialNoList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_serialQueryFromMasterForIT03: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_serialQueryFromMasterForIT03","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 信任收货登记
      wms_acceptance_register:{
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_acceptance_register","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 信任收货查询
      wms_acceptance_query:{
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_acceptance_query","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架异常查询
      wms_co_putaway_containerJoinQuery: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_containerJoinQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架异常交接
      wms_co_putaway_containerJoinAdd: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_containerJoinAdd","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 打印预检单 获取订单详情
      wms_receiving_getIbBookingTaskFroOderPrint: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_getIbBookingTaskFroOderPrint","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 打印预检单 新增打码记录
      wms_receiving_addPrintRecord: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_addPrintRecord","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架异常处理的刷新按钮
      wms_co_putaway_getExContainerNos: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_getExContainerNos","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 重新验收审批  查询按钮
      wms_co_putaway_getExByBizCode: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_getExByBizCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 重新验收通过 驳回
      wms_co_putaway_updateExReviewStatus: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_updateExReviewStatus","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库--上架
      wms_co_putaway_getWorkerTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_getWorkerTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // worker异常-入库--上架重置
      wms_co_putaway_updateWorkerTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_updateWorkerTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 入库整单完验页面-获取异常登记信息
      wms_receiving_receivingTask_ibPurchaseExceptionRegService_getIbPurchaseExceptionRegs: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_ibPurchaseExceptionRegService_getIbPurchaseExceptionRegs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 入库整单完验页面-获取预验收结果明细表信息
      wms_receiving_receivingResult_getReceivingRDList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_getReceivingRDList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 入库整单完验页面
      wms_receiving_tc_tcReceivingVerify: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_tc_tcReceivingVerify","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 入库整单完验页面
      wms_receiving_getNotFinishContainerCnt: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_getNotFinishContainerCnt","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 整单完验
      wms_receiving_ibReceivingService_completeAsnForNonBook: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ibReceivingService_completeAsnForNonBook","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入
      wms_receiving_transfer_onScanCaseNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_transfer_onScanCaseNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入
      wms_receiving_transfer_onScanGoodsNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_transfer_onScanGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入  序列号校验
      wms_receiving_receivingResult_validTransSerialListInCase: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_validTransSerialListInCase","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入  容器完验
      wms_receiving_doContainerFinish2: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_doContainerFinish2","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 批次完验：一般验收，开箱验收预检场景 added by zouminhua3 on 2020.11.27
      wms_receiving_completeInboundBatch: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_completeInboundBatch","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 整单完验：ebay验收场景 added by wuchangzhou3 on 2020.12.14
      wms_receiving_checkInboundBatchIsCompletedFully: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_checkInboundBatchIsCompletedFully","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入  取消验收
      wms_receiving_transfer_UpdateReceivingQty: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_transfer_UpdateReceivingQty","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入
      wms_receiving_receivingResult_getIbReceivingRM: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingResult_getIbReceivingRM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配入  去master获取获取商品的保质期信息
      qryShelfLifeForObj: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryShelfLifeForObj","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查看商品序列号
      wms_receiving_qrySerialsByBusinessCode: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_qrySerialsByBusinessCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查看商品序列号
      wms_receiving_searchReceivingTaskUnCompletedByPage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_searchReceivingTaskUnCompletedByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_getNotFinishContainerList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_getNotFinishContainerList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_checkBoxNumber: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_checkBoxNumber","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_updateUnloadingBoxNumber: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_updateUnloadingBoxNumber","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_receiving2_validateTaskD: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_validateTaskD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_receiving2_queryReceivingWithInboundNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_queryReceivingWithInboundNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_receiving2_queryReceivingWithContainerNo:{
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_queryReceivingWithContainerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_receiving2_queryReverseReceivingWithInboundNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_queryReverseReceivingWithInboundNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 逆向验收-质检品相判定，根据 4 个品相 code 确定商品定级
      wms_inbound_receiving2_determineProductGradeByCode: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_determineProductGradeByCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      /// ///////////////////////////////////////在库/////////////////////////////////////////////////////
      /// /////////////////创建盘点单
      // 商品盘  导入页面 得到数据的方法
      wms_checkstock_getDCCheckList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getDCCheckList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 货主盘  导入页面 得到数据的方法
      wms_checkstock_getOCCheckList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getOCCheckList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 储位盘 得到数据的方法
      wms_checkstock_getSPCheckList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getSPCheckList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 动销盘 得到数据的方法
      wms_checkstock_getDSCheckList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getDSCheckList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //LPN盘
      wms_checkstock_getLpnCheckList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getLpnCheckList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },


      // 获取商品等级列表
      wms_checkstock_getLevelForListByOwner: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getLevelForListByOwner","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      ///  获取货主
      wms_checkstock_getOwnerForList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getOwnerForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      ///  获取动销盘类型
      // wms_checkstock_getMasterTypes: {
      //   uri: serviceUri.checkstockService,
      //   arg0: '{"bizType":"wms_checkstock_getMasterTypes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },

      // 大区 下拉列表数据获取
      wms_checkstock_getArea: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getArea","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 储区 下拉列表数据获取 动盘
      wms_checkstock_getZoneWithOutArStore: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getZoneWithOutArStore","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 储区 下拉列表数据获取储区（排除机区）
      wms_checkstock_getRobotZones: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getRobotZones","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 通道 下拉列表数据获取
      wms_checkstock_getAisle: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getAisle","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 生成单据
      wms_checkstock_saveCheckOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_saveCheckOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查找盘点结果 任务分配
      wms_checkstock_getAssignCheckOrders: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getAssignCheckOrders","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  获得任务列表数据
      wms_checkstock_getCheckTasksByCsOrderId: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getCheckTasksByCsOrderId","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点列表 add by gongbinglai 2019.01.31
      wms_checkstock_getCheckOrders: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getCheckOrders","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 分页查询盘点列表
      wms_checkstock_getCheckOrdersByPage: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getCheckOrdersByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询盘点列表 add by gongbinglai 2019.02.14
      wms_checkstock_getCheckTaskConfirm: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getCheckTaskConfirm","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点单明细
      wms_checkstock_Cyc_getTaskDetail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_Cyc_getTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 动态盘点结束
      wms_checkstock_dyn_dynConfirmOver: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_dyn_dynConfirmOver","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 下一盘
      wms_checkstock_confirmContinue: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_confirmContinue","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 下一盘
      wms_checkstock_sta_confirmOver: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_sta_confirmOver","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 分配
      wms_checkstock_assignCheckTasks: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_assignCheckTasks","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 获取分配用户
      wms_checkstock_queryUserByLogicArea: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_queryUserByLogicArea","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  任务 获取组下的人  有多少条任务
      wms_checkstock_getUnDoneTaskCount: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getUnDoneTaskCount","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 公用 返回下拉框数据
      wms_checkstock_getMasterTypes: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getMasterTypes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 分页查询差异记录
      wms_checkstock_wsCsDiff_queryCsDiffListPagesByQueryBean: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_queryCsDiffListPagesByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //对冲数据查询
      wms_checkstock_wsCsDiff_queryHedging:{
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_queryHedging","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 确认对冲
      wms_checkstock_wsCsDiff_submitHedging:{
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_submitHedging","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 创建盘盈亏单
      wms_checkstock_wsCsDiff_createPlOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_createPlOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 盈亏单查询 分页
      wms_checkstock_wsCsPl_queryCsPlMListPagesByQueryBean: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_queryCsPlMListPagesByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      ///  获取货主
      wms_checkstock_wsCsDiff_closeButton: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_closeButton","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  创建盘盈单  数据列表
      wms_checkstock_wsCsPl_selectPlOrderById: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_selectPlOrderById","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  创建盘盈单  数据列表
      wms_checkstock_getReasonListByReasonCode: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getReasonListByReasonCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 提交申请
      wms_checkstock_wsCsPl_submitCsPlOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_submitCsPlOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 取消盘盈亏
      wms_checkstock_wsCsPl_cancelCsPlOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_cancelCsPlOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 通过
      wms_checkstock_wsCsPl_through: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_through","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 全单驳回
      wms_checkstock_wsCsPl_rejectAll: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_rejectAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 单条驳回
      wms_checkstock_wsCsPl_rejectCsPlD: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsPl_rejectCsPlD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 手动创建移库任务-导入商品明细
      inputManualTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"inputManualTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 手动创建移库任务-校验储源位
      queryLocationToAOS: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryLocationToAOS","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 手动创建移库任务-保存任务
      saveManualTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"saveManualTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取货主 编码、名称、维保客户标识可以做匹配到对应的货主供选择
      queryRmOwnerList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryRmOwnerList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 创建维保单 取消方法
      wms_receiving_cancelMaintainanceOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_cancelMaintainanceOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 创建维保单 确定方法
      wms_receiving_creatingMaintainanceOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_creatingMaintainanceOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //  移库任务分配-查询
      queryTaskList: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsTaskMListByQueryBean","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //  移库任务分配-删除
      deleteTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"delMDTaskStatusBatch","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //  移库任务分配-分配
      taskAssign: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"taskToSetTaskBatch_rep","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单状态
      qryVasStatusForList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_qryVasStatusForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单列表
      qryVasOrderList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_qryVasOrderList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      resetVasOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_resetVasOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 取消vas订单
      cancelVasOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_cancelVasOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取vas订单详情
      qryVasOrderDetail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_qryVasOrderDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取vas订单详情
      completeVasOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_completeVasOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 关闭vas订单详情
      closeVasOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_closeVasOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单任务分配列表
      qryVasOrderAssignList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_qryVasOrderAssignList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单重定位
      vasReLocate: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_vasReLocate","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单列表
      queryCommonUnfinishedVasOrderNoList: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_queryCommonUnfinishedVasOrderNoList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas礼品卡等增值服务列表查询(补打)
      queryVasList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryVasList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryTransferOrderPrintData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryTransferOrderPrintData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取图片base64编码
      getFileBase64String: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_getFileBase64String","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas订单任务分配
      assignVasTask: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"vas_ws_assignVasTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas手工定位详情（组套信息 + 待定位商品明细）
      queryVasLocateDetail: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"vas_ws_queryVasLocateDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas手工定位整单确认（提交定位记录）
      saveVasLocateResult: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"vas_ws_saveLocateResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // vas手工定位操作：查询可定位库存
      queryVasAvailableStock: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"vas_ws_queryAvailableStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_spare_querySpareOrderByPage: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"wms_spare_querySpareOrderByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 备件库申请单-储区非锁定库存查询
      wms_spare_querySpareStock: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"wms_spare_querySpareStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 备件库申请单-商品明细查询
      wms_spare_querySpareOrderDList: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"wms_spare_querySpareOrderDList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 备件库申请单-创建
      wms_spare_createSpareOrder: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"wms_spare_createSpareOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 文件导入日志分页查询
      queryFileImportByPage: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryFileImportByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 文件导入-保存导入记录
      saveFileImport: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"saveFileImport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 增值服务文件上传
      wms_receiving_common_uploadFile: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_common_uploadFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 入库单查询商品信息接口
      wmsReceivingReceivingTaskGetIbReceivingTaskDecorate: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"queryAsnInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 入库单批量查询商品信息接口
      batchQueryAsnInfo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"batchQueryAsnInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 出库单查询商品信息接口
      getOrderInfoByOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getOrderInfoByOutboundNo","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 在库单查询商品信息接口 / 查询商品可用库存信息接口
      stockQueryQueryStock: {
        uri: serviceUri.stockService,
        arg0: '{"bizType":"stock_query_queryStock","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
       // 在库单销毁情况下可关联无库存订单
       qryItemBaseForObj: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryItemBaseForObj","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // VAS创建接口
      createVASByWMS: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"createVASByWMS","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 在库单查询商品信息接口
      // vas_ws_qryVasStatusForList: {
      //   uri: serviceUri.shipmentService,
      //   arg0: '{"bizType":"vas_ws_qryVasStatusForList","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      // },

      /** ****smartqueryService*****/
      getReportLoadData: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getReportLoadData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 轨迹查询
      queryTrackExternally: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryTrackExternally","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 轨迹注册
      registerTrackIfNeeded: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"registerTrackIfNeeded","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 首页积压看板（积压接口）
      queryHomepageBacklogReport: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryHomepageBacklogReport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 首页积压看板（作业中接口）
      queryHomepageProgressingReport: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryHomepageProgressingReport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 首页积压看板（查询条件货主和承运商下拉接口）
      queryHomepageCondition: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryHomepageCondition","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryReportByCondition: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryReportByCondition","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 迁仓历史环境报表数据
      getHistoryReportLoadData: {
        uri: serviceUri.smartHistoryQueryService,
        arg0: '{"bizType":"getReportLoadData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryHistoryReportByCondition: {
        uri: serviceUri.smartHistoryQueryService,
        arg0: '{"bizType":"queryReportByCondition","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryExportTaskPage: {
        uri: serviceUri.asyncExportService,
        arg0: '{"bizType":"queryExportTaskPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      createExportCenterTask: {
        uri: serviceUri.asyncExportService,
        arg0: '{"bizType":"createExportCenterTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      manhourLinkEfficiency: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wmsManHourLinkEfficiency","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wmsManHourLinkCount: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wmsManHourLinkCount","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 辅助分析-单品订单分析
      explosiveAnalysisQuery: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"explosiveAnalysisQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 辅助分析-单品订单分析
      newExplosiveAnalysisQuery: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"newExplosiveAnalysisQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 辅助分析-销售渠道分析
      salesPlatformAnalysisQuery: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"salesPlatformAnalysisQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 自定义配置接口
      insertCustomConditionsConfig: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"insertCustomConditionsConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryCustomConditionsConfigList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryCustomConditionsConfigList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 流水快照查询 3.4.1
      getStockSnapShot: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getStockSnapShot","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      getStockSnapShotWithMonth: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getStockSnapShotWithMonth","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryCarriersForCustomerBackLog: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryCarriersForCustomerBackLog","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // /***********************************B2B发货 开始************************************** */
      queryObShipmentDeliveryList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryObShipmentDeliveryList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryListByPalletNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryListByPalletNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      obShipmentDeliveryScan: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"obShipmentDeliveryScan","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      deleteObShipmentDelivery: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"deleteObShipmentDelivery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      toDeliverGoods: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"toDeliverGoods","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getPrintInterchangeSlip: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPrintInterchangeSlip","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // /***********************************B2B发货 结束************************************** */
      // /***********************************B2B拣货差异确认 开始************************************** */
      queryPickingExceList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPickingExceList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      confirPickPass: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"confirPickPass","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // /***********************************B2B拣货差异确认 结束************************************** */
      // /***********************************B2B打印 开始************************************** */
      printQuery: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryToBReviewPack: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryToBReviewPack","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // /***********************************B2B打印 结束************************************** */
      // /***********************************内配出 开始************************************** */
      // 获取复核任务信息
      wms_inner_getListCheckTaskM: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getListCheckTaskM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 4级扫码
      wms_inner_master_007: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"master_007","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 序列号获取商品信息
      wms_inner_master_003: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"master_003","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取推荐箱号
      wms_inner_getRecommendBox: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getRecommendBox","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取箱子信息
      wms_inner_getCheckBoxByNo: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getCheckBoxByNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 修改箱子数据
      wms_inner_updateCheckBox: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"updateCheckBox","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取需要打印的箱号
      wms_inner_getCheckBoxForTask: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getCheckBoxForTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 添加内配发货箱号
      wms_inner_addInnerCheckBox: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"addInnerCheckBox","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 序列号商品复核的时候，校验序列号的有效性（是否存在、是否已经离库）
      wms_inner_master_012: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"master_012","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取已复核明细
      wms_inner_getListDetailByBoxNo: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getListDetailByBoxNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 删除复核明细
      wms_inner_deleteCheckResult: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"deleteCheckResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 添加商品复核结果信息
      wms_inner_addCheckResult: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"addCheckResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 释放容器
      wms_inner_autoCloseContainer: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"autoCloseContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 满箱
      wms_inner_fulledCheckBox: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"fulledCheckBox","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配复核差异确认
      wms_inner_addCheckDifferDetail: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"addCheckDifferDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_queryOutconfigList: {
        uri: serviceUri.outconfigWebService,
        arg0: '{"bizType":"queryOutconfigList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_insertObInternalOutconfig: {
        uri: serviceUri.outconfigWebService,
        arg0: '{"bizType":"insertObInternalOutconfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_updateObInternalOutconfig: {
        uri: serviceUri.outconfigWebService,
        arg0: '{"bizType":"updateObInternalOutconfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_isExistObInternalOutconfig: {
        uri: serviceUri.outconfigWebService,
        arg0: '{"bizType":"isExistObInternalOutconfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_deleteObInternalOutconfig: {
        uri: serviceUri.outconfigWebService,
        arg0: '{"bizType":"deleteObInternalOutconfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_getListCheckTaskByContainerNo: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getListCheckTaskByContainerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inner_getCheckPallet: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getCheckPallet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getOrderInfoForWave: {
        uri: serviceUri.innerWaveService,
        arg0: '{"bizType":"getOrderInfoForWave","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getAllWareHouseForWave: {
        uri: serviceUri.obInternalMiniWarehouseWebService,
        arg0: '{"bizType":"getAllWarehouse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      getAllDistributeForWave: {
        uri: serviceUri.obInternalMiniWarehouseWebService,
        arg0: '{"bizType":"getAllDistribute","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 内配波次安排
      processWaveManage: {
        uri: serviceUri.innerWaveService,
        arg0: '{"bizType":"setUp","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 通过栈板号查询栈板信息
      wms_inner_getListForFulledPallet: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"getListForFulledPallet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 满板
      wms_inner_fulledPallets: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"fulledPallets","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 取消满板
      wms_inner_cancelFulledPallets: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"cancelFulledPallets","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取复核台信息
      wms_inner_getPlatformInfo: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"master_004","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 占用未被占用的复核台
      wms_inner_occupyPlatformNo: {
        uri: serviceUri.innerService,
        arg0: '{"bizType":"master_006","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取发货时需要的合流主档+合流明细
      wms_inner_getObInternalConfluenceMShip: {
        uri: serviceUri.innerConfluenceService,
        arg0: '{"bizType":"getObInternalConfluenceMShip","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.InnerDelivery.Confluence.ObInternalConfluence"}'
      },
      // 执行发货
      wms_inner_runShip: {
        uri: serviceUri.innerShipWebService,
        // obInternalShipService,ship
        arg0: '{"bizType":"ship","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      /**
       *  wangzhi 2021-4-12   begin
       *  B2B  outbound
       *  根据订单号获取发货拦截订单信息
      */
      querySMInterceptOrderLists: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"querySMInterceptOrderLists","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      /**
       *
       * B2B发货拦截重构checkWorker
       */
      sendGoodsInterceptAfter: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"sendGoodsInterceptAfter","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      /**
       *
       * b2b发货拦截将零散订单添加到新的空闲栈板中
       */
      addCheckPalletInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"addCheckPalletInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // /***********************************内配出 结束************************************** */

      // /***********************************复合 开始************************************** */
      // 查询复合台
      master_004: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_004","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      querySimpleEquipmentList: {
        uri: serviceUri.masterService,
        arg0: `{"bizType":"querySimpleEquipmentList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}`
      },
      queryDicDetailList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDicDetailList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryDicDetailAndConfigList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDicDetailAndConfigList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 占用复合台
      master_006: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_006","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 激活复合台
      customer_214: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_214","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 切换复合台
      master_005: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_005","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取打包类型
      customer_99: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_99","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据容器号获取容器号里的全部订单
      customer_100: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_100","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getLabelInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getLabelInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 向打包机请求耗材
      queryConsumerFromPackMachine: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_2012","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 轻量级包裹明细查询
      getContainerInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_98","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据墙号获取待复核打包信息
      customer_101: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_101","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取格口号及对应相关信息
      getSlotAndReletedInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getSlotAndReletedInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取所有格口信息
      getAllSlotInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getAllSlotInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 判断格口是否全部释放
      isAllSlotsRelease: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"isAllSlotsRelease","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM门店分拨扫描包裹号
      scanPackageNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanPackageNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM门店分拨扫描格口号
      scanSlotNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanSlotNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM门店清空格口号
      cleanSlot: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"cleanSlot","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM获取格口明细
      getStoreDetail: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getStoreDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM删除已扫描包裹
      deleteScanedPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"deleteScanedPackage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM校验本格口本波次对应的订单是不是都已经打包
      checkAllOrderHasBeenPackaged: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkAllOrderHasBeenPackaged","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM强制完成格口
      forceCompleteSlot: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"forceCompleteSlot","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM查询格口下待合流订单明细
      findNotConfluenceDetail: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"findNotConfluenceDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据容器号获取容器号里的全部已復核订单
      customer_119: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_119","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // B2B复核页面跟据输入箱码数据定位此输入值是箱规码还是唯一箱码
      customer_121: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_121","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // B2B复核页面跟据订单号查询已复核明细
      customer_122: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_122","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 添加栈板号
      box_007: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_007","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 校验箱号所在栈板是否满板
      box_008: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_008","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 校验箱号所在栈板是否满板
      box_009: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_009","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 操作满板
      box_010: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_010","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 校验栈板是否满板
      box_011: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_011","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 操作换板
      switchPallet: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"switchPallet","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 校验订单对应的所有栈板是否都已满板
      checkAllPalletFullOrNot: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkAllPalletFullOrNot","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据周转箱号获取周转箱数据
      queryTurnoverBox: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryTurnoverBox","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 4级扫码
      master_007: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_007","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 序列号扫码
      master_003: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_003","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 扫描二维码获取序列号
      master_030: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_030","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 验证序列号扫码
      master_012: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_012","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 获取系统id
      getSystemId: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getSystemId","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取包裹标签
      master_015: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_015","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 复合结果
      customer_200: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_200","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      calculateSoftWrapDimWeight: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"calculateSoftWrapDimWeight","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 复合结果
      insertPackageOperationDetail: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"insertPackageOperationDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 复合结果
      getOrderRecheckStatus: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getOrderRecheckStatus","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 单包裹信息
      customer_217: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_217","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
       // 包裹重量校验
      common_037: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_037","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 托面单补打
      getPalletPrintLabelParam: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPalletPrintLabelParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 更新包裹长宽高重
      updatePackageMLogisticsAttributes: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updatePackageMLogisticsAttributes","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 更新包裹
      modifyPackageNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"modifyPackageNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 差异场景关容器(call单)前修改最后一个包裹号
      diffChangePackageNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"diffChangePackageNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 单包裹信息
      customer_218: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_218","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据复核数量获取fnsku信息
      queryFnSkuInfoByQty: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryFnSkuInfoByQty","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 追觅VC根据商品获取补打信息
      rePrintGoodsLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"rePrintGoodsLabel","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取追觅BOL打印信息
      queryLabelsOfOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryLabelsOfOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 危险品补打
      reprintAdr: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"reprintAdr","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 箱规复核
      customer_219: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_219","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 通过upc获取耗材
      master_026: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_026","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 通过upc获取耗材
      scanConsumableByOwnerFallback: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanConsumableByOwnerFallback","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取下拉列表的字典值
      master_008: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_008","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      /// 获取上架容器状态是否可用
      master_018: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_018","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 关闭容器操作
      customer_201: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_201","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // HKM订单关闭容器操作
      customer_2011: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_2011","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // B2B关闭容器操作
      customer_206: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_206","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 出库-复核-关闭容器
      taskContainerClose: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskContainerClose","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 出库-复核-差异确认
      taskOrderDiffConfirm: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskOrderDiffConfirm","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      removeCheckData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"removeCheckData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 解除容器和复核台的绑定操作
      common_006: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_006","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据周转筐号或是订单号获取待打包的订单
      customer_102: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_102","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 根据订单号获取订单信息
      customer_106: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_106","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量获取三方快递的运单号
      wave_001: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_001","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 添加打包结果
      common_023: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_023","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询master获取真知码及对应的图片流
      customer_202: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_202","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号获取发票信息
      wave_011: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_011","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号获取用于包裹标签的订单信息
      wave_012: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_012","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 从master配置的是否隐藏客户姓名和电话的信息
      master_025: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_025","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      /// /////////////////////////////客单复合打包一体化结束////////////////////////////////////////////////////////
      /* *****checkService*****/
      wms_check_customer_100: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_100","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      wms_check_master_004: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_004","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getHotSales: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHotSales","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_006: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_006","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_005: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_005","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_214: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_214","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_common_019: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_019","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_008: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_008","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_203: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_203","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_003: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_003","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_012: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_012","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_007: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_007","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_specialRules_filter: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_specialRules_filter","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_check_common_006: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_006","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_200: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_200","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_104: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_104","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_204: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_204","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_018: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_018","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_201: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_201","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_customer_2011: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_2011","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // add by gongbinglai 2019.03.12  start 非客单复核
      queryNonCustomerOrdersByContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskCheck_001","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getCheckPalletByPalletNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_033","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getUnFullBoardPalletByOUtboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_034","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getCheckBoxByNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_027","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      scanByCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanByCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getAllCountryCodes: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getAllCountryCodes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryDangerousPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDangerousPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getGoodsInfoByCodeFour: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_007","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getGoodsByGoodsNos: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanBatchGoodsInfoByCodeFour","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getGoodsInfoBySerialNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_003","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      addCheckResultForNonCustomer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskCheck_101","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getCheckRListByTaskNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_030","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      fullBoxForOrderTask: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_032","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      processFullBoard: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskCheck_103","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      delCheckRForOrderTask: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_031","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getCheckPalletByNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_028","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      closeContainerForOrderTask: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"taskCheck_104","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getSequenceNoForBoxNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"box_004","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      addCheckBox: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"b2b_006","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getOrgWarehouseName: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_011","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_check_master_029: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_029","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量获取运单号
      batchGetWayBilNumber: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchGetWayBilNumber","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // add by gongbinglai 2019.03.12  end 非客单复核

      // /***********************************复合 结束************************************** */
      // /***********************************跨境CN23打印 开始************************************** */
      // 查询打印列表
      queryPrintCN23: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPrintCN23","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 封装3PL面单参数
      query3PLFaceParams: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"query3PLFaceParams","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // CN23 url base64转码接口
      convertBase64: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"convertBase64","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 导出
      exportCN23List: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"exportCN23List","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询最新流水号
      getLatestBillNum: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getLatestBillNum","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 更新到最新的流水
      updateLatestBillNum: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateLatestBillNum","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      confirmPackageDiffer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"confirmPackageDiffer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      singleVerifyCheckDiffGoodsStock: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"singleVerifyCheckDiffGoodsStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      validateHugeSerial: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"validateHugeSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // /***********************************跨境CN23打印 结束************************************** */

      saveCheckCacheData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"saveCheckCacheData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getCheckCacheData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getCheckCacheData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      removeCheckCacheData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"removeCheckCacheData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // /***********************************任务分配 开始************************************** */
      queryAssignAutoMode: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryAssignAutoMode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      updateAssignAutoMode: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateAssignAutoMode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      qryCarrierForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryCarrierForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryCarriers: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCarriers","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryOwnerForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryOwnerForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qrySiteByNameForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qrySiteByNameForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qrySiteByNameForListWithPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qrySiteByNameForListWithPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qrySiteByNameForListForTask: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"qrySiteByNameForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getSiteSelector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getSiteSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getSendTimes: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getSendTimes","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryObShipmentMIds: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryObShipmentMIds","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      totalPendingTasks: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"totalPendingTasks","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      totalPendingSlots: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"totalPendingSlots","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      totalFreeSpace: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"totalFreeSpace","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getAssignConfig: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getAssignConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryObShipmentMs: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryObShipmentMs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 任务分配自动组波查询接口
      queryDynamicObShipmentMs: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryDynamicObShipmentMs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 任务分配自动组波转手工任务接口
      doChangeDynamicObShipmentMsToTask: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"doChangeDynamicObShipmentMsToTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 任务分配自动组波查询出库单的组单日志
      queryDynamicOperationLogOfOrder: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryDynamicOperationLogOfOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      
      getObLocateDs: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getObLocateDs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getTaskAssignLock: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getTaskAssignLock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      qryDeliveryForList: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"qryDeliveryForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      releaseTaskAssignLock: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"releaseTaskAssignLock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      doTaskAssign: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"doTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryOwnerNo: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryOwnerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryCarrierNo: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryCarrierNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getTaskLocateDList4CarrierNo: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getTaskLocateDList4CarrierNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      doCCTaskAssign: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"doCCTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      doBigWaveTaskAssign: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"doBigWaveTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      cancelLocateD: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"cancelLocateD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      clearCache: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"clearCache","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      forceReleaseTaskAssignLock: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"forceReleaseTaskAssignLock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getOutboundTypeCounts: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getOutboundTypeCounts","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      splitBySkuAndCell: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"splitBySkuAndCell","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      generateTaskPageNo: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"generateTaskPageNo","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      b2bDoTaskAssign: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"b2bDoTaskAssign","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询组单规则列表-分页
      getGroupTaskRuleMListByPage: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getGroupTaskRuleMListByPage","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询组单规则
      getGroupTaskRuleM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getGroupTaskRuleM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 新增组单规则
      saveGroupTaskRuleM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"saveGroupTaskRuleM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 修改组单规则
      updateGroupTaskRuleM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateGroupTaskRuleM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 复制组单规则
      copyGroupTaskRuleM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"copyGroupTaskRuleM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 修改组单规则状态
      updateGroupTaskRuleMByStatus: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateGroupTaskRuleMByStatus","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 删除组单规则
      deleteGroupTaskRuleM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"deleteGroupTaskRuleM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取默认组单规则-
      getDefaultGroupTaskRuleD: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getDefaultGroupTaskRuleD","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询组单模版列表
      getGroupTaskTemplateMListByParam: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getGroupTaskTemplateMListByParam","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询组单模版列表
      pageGroupTaskTemplateMListByParam: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"pageGroupTaskTemplateMListByParam","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 新增模版
      saveGroupTaskTemplateM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"saveGroupTaskTemplateM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查看模版
      getGroupTaskTemplateM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getGroupTaskTemplateM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      updateGroupTaskTemplateM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateGroupTaskTemplateM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      updateGroupTaskTemplateMByStatus: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateGroupTaskTemplateMByStatus","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      deleteGroupTaskTemplateM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"deleteGroupTaskTemplateM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      updateGroupTaskTemplateMByTop: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"updateGroupTaskTemplateMByTop","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getDynamicTaskForToday: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getDynamicTaskForToday","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getDynamicTaskMListForToday: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getDynamicTaskMListForToday","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getDynamicTaskDListForToday: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"getDynamicTaskDListForToday","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      resetDynamicTaskM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"resetDynamicTaskM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      clearDynamicTaskM: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"clearDynamicTaskM","uuid":"2","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // /***********************************任务分配 结束************************************** */      queryPrintInfoList: {
      queryPrintInfoList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_010","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      querySupplierList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"handover_102","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      querySupplierDetails: {
        uri: serviceUri.shipmentService, // ObCheck
        arg0: '{"bizType":"handover_103","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 企配中心拣货单-查询异常订单明细
      printAbnormalOrderDetails: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printAbnormalOrderDetails","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryEIRNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"handover_104","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      handover_202: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"handover_202","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      handover_203: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"handover_203","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      master_013: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"master_013","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      querySystemConfigList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"querySystemConfigList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 包裹换单
      queryPackageInfoByscanCode: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPackageInfoByscanCode","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 包裹换单
      queryPackageInfoByscanCodeOCReplace: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPackageInfoByscanCodeOCReplace","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取发票信息列表
      queryObExpandList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryObExpandList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取发票货主
      queryObExpandOwners: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryObExpandOwners","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-获取扫描包裹的信息 如果不属于当前正在扫描的门店或者重复扫描都失败
      checkPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkPackage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-获取需要门店打包的包裹数量
      getNeedStorePackageNum: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getNeedStorePackageNum","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-获取当前批次该门店未门店打包的包裹信息
      queryPackagesInfoWithType: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPackagesInfoWithType","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-满包裹
      submitStorePackages: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"submitStorePackages","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-满包裹数据校验
      checkWhetherThePackageEachOrderIsAllIn: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkWhetherThePackageEachOrderIsAllIn","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-满包裹
      getCheckRByOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getCheckRByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 门店打包-更新运单号
      updateShipNos: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateShipNos","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取订单详情
      queryShipmentMExpandAttr: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryShipmentMExpandAttr","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
       //根据按商品提交复核信息
       submitCheckData: {
        uri:  serviceUri.shipmentService,
        arg0: '{"bizType":"submitCheckData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
       //根据任务单号+订单号获取待复核数据和已复核数据
       getCheckDataByTaskPageNoAndOrderNo: {
        uri:  serviceUri.shipmentService,
        arg0: '{"bizType":"getCheckDataByTaskPageNoAndOrderNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      //提交满包裹
      fullPackage: {
        uri:  serviceUri.shipmentService,
        arg0: '{"bizType":"fullPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 包裹换单
      savePackageReplacePrintLog: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"savePackageReplacePrintLog","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号，包裹号获取已完成独立打包的订单信息
      queryRepackagePrintInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryRepackagePrintInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号，包裹号，门店包裹号获取已完成独立打包的订单信息
      queryRepackageBoxListInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryRepackageBoxListInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号，包裹号，门店包裹号获取已完成独立打包的订单正向面单信息
      queryForwardLabelInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryForwardLabelInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号，包裹号，取已完成独立打包的订单包裹号标签
      queryPackageCodeLabelInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPackageCodeLabelInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据出库单号查询面单打印信息
      queryWaybillOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryWaybillOrderInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据出库单号查询发货单打印信息
      queryDeliveryOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDeliveryOrderInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据出库单号查询发货单打印信息【批量】
      batchQueryDeliveryOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDeliveryInfoByOutboundNos","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据出库单号查询出库单打印信息
      queryOutboundOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryOutboundOrderInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 海康 获取订单下的所有包裹
      getHikPackingList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHikPackingList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 海康 获取包裹详情信息
      getHikPackagePackingList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHikPackagePackingList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 海康 获取包裹详情信息（补打）
      getHikPackagePackingListAfterCheck: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHikPackagePackingListAfterCheck","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 海康 获取pod单信息
      getHikPodInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHikPodInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getNioPackingList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getNioPackingList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号和组织机构信息获取订单的基础信息（shipment_m和expand）
      queryPrintOrderLists: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPrintOrderLists","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryPackingListInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPackingListInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号和组织机构信息修改订单的基础信息（shipment_m和expand）
      modifyPrintOrderData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"modifyPrintOrderData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号、包裹号获取已完成打包订单和复核结果详情
      queryRepackagePrintInvoiceInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryRepackagePrintInvoiceInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号、包裹号获取已完成打包订单和复核结果详情
      queryPrePrintOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPrePrintOrderInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号、包裹号获取已完成打包订单和复核结果详情
      getPalletPrintSsccParam: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPalletPrintSsccParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号、包裹号获取已完成打包订单和复核结果详情
      queryOrderInfoByOutboundNos: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryOrderInfoByOutboundNos","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据订单号列表获取已完成打包订单和复核结果详情列表
      queryRepackagePrintList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryRepackagePrintList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // queryRepackagePrintInvoiceInfo
      queryShelfLifeGoodsInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryShelfLifeGoodsInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      /*** WorkerException ***/
      wms_ob_queryFailedList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_queryFailedList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wms_ob_updateRedoQty: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_updateRedoQty","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wms_ob_queryEmployeeInfo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"queryEmployeeInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wms_ob_getTaskLocateDList4OwnerNo: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getTaskLocateDList4OwnerNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      getDynamicTaskLocateDList4OwnerNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"getDynamicTaskLocateDList4OwnerNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      getWorkMonitorList: {
        uri: serviceUri.innerWorkService,
        arg0: '{"bizType":"getWorkMonitorList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      manageWorkMonitor: {
        uri: serviceUri.innerWorkService,
        arg0: '{"bizType":"manageWorkMonitor","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_ob_taskassign_queryFailedTask: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"wms_ob_taskassign_queryFailedTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_ob_taskassign_resetTaskToRedo: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"wms_ob_taskassign_resetTaskToRedo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      exceptionWebService_qryWorkException: {
        uri: serviceUri.waveService,
        arg0: '{"bizType":"exceptionWebService.qryWorkException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}'
      },
      exceptionWebService_processWorkException: {
        uri: serviceUri.waveService,
        arg0: '{"bizType":"exceptionWebService.processWorkException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}'
      },
      // receiving_workerOverTimes_getWorkerOverTimes: {
      //   uri: serviceUri.receivingService,
      //   arg0: '{"bizType":"receiving_workerOverTimes_getWorkerOverTimes","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      // receiving_workerOverTimes_resetOverTimesWorker: {
      //   uri: serviceUri.receivingService,
      //   arg0: '{"bizType":"receiving_workerOverTimes_resetOverTimesWorker","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      // getExceptAsnWorker: {
      //   uri: serviceUri.receivingService,
      //   arg0: '{"bizType":"getExceptAsnWorker","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      // resetExceptAsnWorker: {
      //   uri: serviceUri.receivingService,
      //   arg0: '{"bizType":"resetExceptAsnWorker","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      getAbilities: {
        uri: serviceUri.masterService,
        // arg0: '{"bizType":"master_027","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
        arg0: '{"bizType":"getAbilities","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 批量获取货主能力
      queryAbilityList: {
        uri: serviceUri.masterService,
        // arg0: '{"bizType":"master_027","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
        arg0: '{"bizType":"queryAbilityList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      checkAbility: {
        uri: serviceUri.masterService,
        // arg0: '{"bizType":"master_028","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
        arg0: '{"bizType":"checkAbility","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      common_009: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_009","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      common_008: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_008","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryFailBackSend: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryFailBackSend","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      rollbackFailBackSend: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"rollbackFailBackSend","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryFailTask: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryFailTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      rollbackFailTask: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"rollbackFailTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryExceptionTask: {
        uri: serviceUri.stockService,
        arg0: '{"bizType":"queryExceptionTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      updateExceptionTask: {
        uri: serviceUri.stockService,
        arg0: '{"bizType":"updateExceptionTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      TqueryExceptionTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryExceptionTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      TupdateExceptionTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"updateExceptionTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // wms_co_putaway_getWorkerTask: {
      //   uri: serviceUri.putawayService,
      //   arg0: '{"bizType":"wms_co_putaway_getWorkerTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      // wms_co_putaway_updateWorkerTask: {
      //   uri: serviceUri.putawayService,
      //   arg0: '{"bizType":"wms_co_putaway_updateWorkerTask","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },

      /** * Biz Exception ***/
      // outboud init exception
      selectException: {
        uri: serviceUri.waveService,
        arg0: '{"bizType":"selectException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}'
      },

      processException: {
        uri: serviceUri.waveService,
        arg0: '{"bizType":"processException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}'
      },

      // locate exception
      queryLocateExceptionPage: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryLocateExceptionPage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      manualAgainLocate: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"manualAgainLocate","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      doLocateExceptionByParam: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"doLocateExceptionByParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      doManualLocateWsByParam: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"doManualLocateWsByParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryCarrierNoForLocateException: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryCarrierNoForLocateException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      doLotRelocateByParam: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"doLotRelocateByParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      /** * taskAssigh exception***/
      qtyTaskassignExcetion: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"wms_ob_queryAssignExpDataWithPage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      executeTaskassignExcetion: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"wms_ob_executeHandleExp","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      /** * exception ***/
      queryTroubleOrders: {
        uri: serviceUri.illService,
        arg0: '{"bizType":"ill_ws_queryTroubleOrders","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      relocate: {
        uri: serviceUri.illService,
        arg0: '{"bizType":"ill_ws_relocate","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      toTroubleOrder: {
        uri: serviceUri.illService,
        arg0: '{"bizType":"ill_ws_toTroubleOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      /** * splitOrder ***/
      splitOrder: {
        uri: serviceUri.orderCenterService,
        arg0: '{"bizType":"split","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 获取订单详情及订单扩展信息
      getOrderByOutboundNo: {
        uri: serviceUri.orderCenterService,
        arg0: '{"bizType":"orderService_getOrderMain","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 订单创建
      orderCreation: {
        uri: serviceUri.waveService,
        arg0: '{"bizType":"downLoadShipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.wave"}'
      },

      // 获取面单信息
      getFaceInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_getFaceInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 保存运单号
      customer_215: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_215","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 单包裹保存运单号
      setPackageTrackingNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"setPackageTrackingNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据包裹号获取包裹信息
      customer_103: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_103","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取订单主档信息
      common_002: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"common_002","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 添加重新打印包裹标签
      customer_205: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"customer_205","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 从初始化获取订单附属性信息
      wave_008: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wave_008","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取容器编号初始值
      max_container_code_for_each_type: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryMaxContainerCodeForEachType","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      /** ****************************SAAS接口 开始***********************************/
      submitWarehouseConfig: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"submitWarehouseConfig","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addArea: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateArea: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteArea: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteArea","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryAreaForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryAreaForList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryAreaByNoNameForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryAreaByNoNameForList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addZone: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addZone","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteZone: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteZone","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateZone: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateZone","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryZonePlanList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryZonePlanList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateEquipmentById: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateEquipmentById","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryZoneForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryZoneList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_qryLocationspecForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryLocationSpecList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_qryLotAttributeDefForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryLotAttributeDefForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      query_all_carrier: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"query_all_carrier","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_addLocationspec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addLocationspec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_delLocationspec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"delLocationspec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_modifyLocationspec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updLocationspec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      saveCalculationPeriod: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveSalesCycle","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addEquipment: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addEquipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addDiccataLog: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addDiccataLog","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryDiccataLogForSelect: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryDiccataLogForSelect","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryWkGrp: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryWkGrp","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getWkGrpByEquipNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getWkGrpByEquipNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryComplexEquipmentList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryComplexEquipmentList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      saveEquipment: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveEquipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addEquipWorkGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addEquipWorkGroup","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      getAislelPickupSeqForPageList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getAislelPickupSeqForPageList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryAisleByZoneForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryAisleByZoneForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      exportData: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"exportData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      importData: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"importData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateAisldePickupSeq: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateAisldePickupSeq","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteByCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteByCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryEquipmentWkGroupForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryEquipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getEquipment: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getEquipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryDataDictionaryGroupForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDataDictionary","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getDetails: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getDetails","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteEquipment: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteEquipment","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      deleteDataDictionary: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteDataDictionary","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      deleteDataDetails: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifyDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      addSystemParam: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addSystemConfig","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      querySystemParamList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySystemConfigForList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      editSystemParam: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifySystemConfig","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteSystemParam: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteSystemConfig","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 获取货主
      wms_master_getOwners: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getOwners","uuid":"1","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 分页查询货主
      wms_master_qryOwnersForPageList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryOwnersForPageList","uuid":"1","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询货主
      wms_master_queryOwnerByNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryOwnerByNo","uuid":"1","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商品列表
      wms_master_queryProductList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryProductList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 三级品类下拉（上架策略储区锁定用，不by仓）
      wms_master_qryThirdCatalogForList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryThirdCatalogForList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商品列表 这个是用来导出的
      wms_master_queryProductListAll: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryProductListAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 获取商品
      wms_master_getProduct: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getProduct","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 保存商品
      wms_master_saveProduct: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveProduct","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除商品
      wms_master_deleteProduct: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteProduct","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询条码列表
      wms_master_queryBarcodeList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryBarcodeList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 添加条码
      wms_master_addBarcode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addBarcode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除条码
      wms_master_deleteBarcode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteBarcode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 获取商品储区对照
      wms_master_getGoodsZoneRef: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getGoodsZoneRef","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 保存商品储区对照
      wms_master_saveGoodsZoneRef: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveGoodsZoneRef","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 批量更新商品扩展属性
      wms_master_updateItemBaseExtAttr: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateItemBaseExtAttr","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 安全库存导入
      wms_master_importSafeStock: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"importSafeStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商品等级列表
      wms_master_queryProductLevelListForPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryProductLevelListForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 添加商品等级
      wms_master_addProductLevel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addProductLevel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除商品等级
      wms_master_deleteProductLevel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteProductLevel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 获取单号
      wms_masterservice_getSequence: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"nextStringOfDaySetLength","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteOwners: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteOwners","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addOwners: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addOwners","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_master_queryContainer: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询rebin墙的下一个起始容器信息
      wms_master_queryNextContainer: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryNextContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_addContainer: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"insertMultiContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_modifyContainerSpecification: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifyContainerSpecification","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_queryCellByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCellByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_batchGenarateCell: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchGenarateCell","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_batchGenarateCellNew: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addLocation","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_updateLocInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateLocInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_importLocInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"importLocInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_batchDeleteCell: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchDeleteCell","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteLocation: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteLocation","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_queryCellListAll: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCellListAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_querySuppilerByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySuppilerByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_master_queryCarrierByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCarrierByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_master_queryCarrierProductListByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCarrierProductListByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_addCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_master_queryHandoverGroupList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryHandoverGroupList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_master_getCarrierProductGroupSelector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getCarrierProductGroupSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_addCarrier: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addCarrier","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_masterservice_deleteCarrier: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteCarrier","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      wms_booking_queryCapacityTimeslot: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_queryCapacityTimeslot","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_booking_updateBookingCapacity: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_updateBookingCapacity","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_booking_insertBookingData: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_insertBookingData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_booking_insertBookingByTimeslot: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_insertBookingByTimeslot","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_booking_getBookingTimeslotCapacity: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_getBookingTimeslotCapacity","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_booking_checkPrivateBookingData: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_checkPrivateBookingData","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_booking_acceptBooking: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_inbound_booking_acceptBooking","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_parcelHandover_deleteParcelByShipNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_deleteParcelByShipNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_queryParcelByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_queryParcelByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_insertParcelBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_insertParcelBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_queryParcelAndOutboundByShipNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_queryParcelAndOutboundByShipNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryParcelByShippingContainerNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryParcelByShippingContainerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      insertParcelByShippingContainerNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"insertParcelByShippingContainerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      addDeliveryOperationDetail: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"addDeliveryOperationDetail","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      pageDeliveryBacklog: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageDeliveryBacklog","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}',
      },
      unloadingQueryFile: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_ib_unloading_queryFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}',
      },
      pageQueryDeliveryTaskM: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageQueryDeliveryTaskM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      pageDeliveryOperationDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageDeliveryOperationDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      pageQueryDeliveryTaskMDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageQueryDeliveryTaskMDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wms_parcelHandover_updateHandoverStatusBySuccess: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_updateHandoverStatusBySuccess","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_getGXServiceProviderMark: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_checkTrunkCarrierAbilityByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_checkHandoverBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_checkHandoverBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_insertParcelOneBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_insertParcelOneBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_batchInsertParcelOneBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_batchInsertParcelOneBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_parcelHandover_queryPackageCountByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_queryPackageCountByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据批次号查询发票集信息
      wms_parcelHandover_getGoodsOutBoundNumByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPackageMDByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 根据批次号查询发票集信息
      getHandoverMsgByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getHandoverMsgByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接 - 列表查询
      wms_parcelBatchHandover_queryBatchHandoverInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryBatchHandoverInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接
      wms_parcelBatchHandover_batchHandoverHandle: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchHandoverHandle","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量将按托订单转按箱
      wms_parcelBatchHandover_batchUpdateExpectPackagingMode: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchUpdateExpectPackagingMode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接 - 获取批次号明细
      wms_parcelBatchHandover_printHandoverSheet: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printHandoverSheet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 单据打印 - 小鹏汽车打印明细
      printPalletHandoverSheet: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printPalletHandoverSheet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接 - 查询普通包裹打印manifest
      wms_parcelBatchHandover_queryNormalPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryNormalPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接 - 查询普通包裹打印manifest
      wms_parcelBatchHandover_updateManifestPrintResult: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateManifestPrintResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量交接 - 查询普通包裹打印manifest
      wms_parcelBatchHandover_queryDangerousPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDangerousPackageByBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 称重量方 - 获取默认单位
      wms_parcelWeighingSquare_getWeighingSquareConfigUnit: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getWeighingSquareConfigUnit","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 称重量方 - 提交数据
      wms_parcelWeighingSquare_weighingSquareHandle: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"weighingSquareHandle","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 生成批次号
      wms_parcelHandover_generateHandoverBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"wms_parcelHandover_generateHandoverBatchNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

      // 获取 当前仓的自绘面单配置
      wms_queryFaceSheet: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryFaceSheet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryDispatchInquiryStatus: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDispatchInquiryStatus","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      insertShipmentLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"insertShipmentLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      deleteShipmentLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"deleteShipmentLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 待手工定位
      wms_queryShipmentMByManualLocate: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryShipmentMByManualLocate","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 待手工定位
      queryShipmentMByManualLocateByPage: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryShipmentMByManualLocateByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询可全选的订单总数
      querySelectAllOrderLen: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryShipmentMByManualLocateByStatus","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询提总爆品的可选商品编码列表
      queryExplosiveSkuCodeList: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"explosiveAnalysisQueryByManualLocate","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询订单下明细
      wms_queryManualLocateShipmentDByOutboundNo: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryManualLocateShipmentDByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询可定位储位库存信息
      wms_queryManualLocateStockInfo: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryManualLocateStockInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询已定位明细
      wms_queryManualLocateDetailByOrderAndSku: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryManualLocateDetailByOrderAndSku","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 转自动定位
      wms_resetManualFlag: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"resetManualFlag","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 整单确认
      wms_manualLocateOrderConfirm: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"manualLocateOrderConfirm","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 释放预占
      wms_manualLocateOrderPreQtyDecrease: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"manualLocateOrderPreQtyDecrease","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 确认预占
      wms_saveLocateInfoAndStockLocation: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"saveLocateInfoAndStockLocation","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 分页查询订单下明细
      wms_queryPagedManualLocateStockInfo: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryPagedManualLocateStockInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 分页查询订单下明细
      wms_queryPagedManualLocateDetailByOrderAndSku: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryPagedManualLocateDetailByOrderAndSku","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询订单商品明细分页
      wms_queryPageManualLocateShipmentDByOutboundNo: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryPageManualLocateShipmentDByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_master_queryOwnerList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryOwnerList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_getExtendsOfZone: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getExtendsOfZone","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_qryDicDetailByCatalog: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryDicDetailByCatalog","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_queryLocSpecPlanList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryLocSpecPlanList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_deleteLocSpecPlan: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteLocSpecPlan","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_master_saveLocSpecPlan: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"saveLocSpecPlan","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_booking_qryContainerForList: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_selectContainerCapacityByWarehouseNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_booking_insertNewContainer: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_insertNewCapacity","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_booking_deleteContainer: {
        uri: serviceUri.bookingService,
        arg0: '{"bizType":"wms_booking_deleteBatchCapacityMetadataById","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_inbound_receiving_getPictures: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving_getPictures","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_inbound_receiving_downloadCertificateFile: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving_downloadCertificateFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_inbound_queryComplianceFileByConditionPage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_queryComplianceFileByConditionPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      wms_inbound_reviewComplianceFile: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_reviewComplianceFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 新的预检单打印
      wms_inbound_printByAsnNo: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_printByAsnNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 重跑预流向
      wms_inbound_calculateFlowFinish: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_calculateFlowFinish","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 海柔侧容器可用性校验
      wms_receiving_ctuContainerVerify: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ctuContainerVerify","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 合单验收列表查询
      wms_receiving_queryIbReceivingTaskMergeByPage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_queryIbReceivingTaskMergeByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 合单详情查询
      wms_receiving_queryMergeInboundDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_queryMergeInboundDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 提交合单数据
      wms_receiving_mergeIbAsnOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_mergeIbAsnOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //  取消合单
      wms_receiving_cancelMergeIbAsnOrder: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_cancelMergeIbAsnOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 循环盘点获取主明细
      wms_checkstock_cyclInv_queryInventoryMs: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_cyclInv_queryInventoryMs","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 获取差异管理列表信息
      wms_checkstock_cyclInv_queryDiffInventoryMs: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetDiffList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 校验差异复核人不能是盘点
      wms_check_inventoryCycle_IsCCWorker: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_IsCCWorker","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 差异核实
      wms_check_inventoryCycle_SetDiffCheckResult: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_SetDiffCheckResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点单详细信息
      inventoryCycle_GetInventoryM: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetInventoryM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点单未盘点任务信息
      inventoryCycle_GetUnTask: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetUnTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点单已盘点任务总数
      inventoryCycle_GetTaskedQty: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetTaskedQty","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 查询盘点单盘点已任务信息
      inventoryCycle_GetTasked: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetTasked","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询盘点任务进度信息
      inventoryCycle_getInventoryTaskProcess: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_getInventoryTaskProcess","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 检查做过此盘点单差异复核的人员不能再做盘点
      inventoryCycle_CheckWkNo: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_CheckWkNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 分配盘点任务前校验用户是否可用
      inventoryCycle_IsChecker: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_CheckWkNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 循环盘点一盘人验证
      inventoryCycle_GetCCWkno: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetCCWkno","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 循环盘点二盘人验证
      inventoryCycle_GetCCWknoSecond: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_GetCCWknoSecond","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 循环盘点二盘人验证
      inventoryCycle_deleteInventoryTask: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_deleteInventoryTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 创建一盘盘点任务
      inventoryCycle_CreateTaskFromD: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_CreateTaskFromD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 创建二盘盘点任务
      inventoryCycle_CreateReCheckTask: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_CreateReCheckTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 库存操作
      wms_checkstock_getStockFrozenInfo: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getStockFrozenInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 库存操作（锁定库存）
      wms_checkstock_freezeStock: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_freezeStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 库存操作（解锁库存）
      wms_checkstock_unfreezeStock: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_unfreezeStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 库存操作（批量解锁库存）
      wms_checkstock_batchUnfreezeStock: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_batchUnfreezeStock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 循环盘点 盘点统计明细
      wms_checkstock_cyclInv_queryCcReport: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_cyclInv_queryCcReport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 盘点单导出
      wms_checkstock_queryCsTaskDetail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_queryCsTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 分页查询商品箱码信息
      wms_master_qrySkuBoxDetailsForPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qrySkuBoxDetailsForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 商品管理-扩展属性
      wms_master_qryExpandProperties: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryExpandProperties","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 商品管理-保质期属性
      wms_master_qryShelflife: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryShelflife","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 商品管理-欧代负责人信息
      wms_master_qryResponsePersonInfoByGoodsNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryResponsePersonInfoByGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 分页查询个性化生产组
      wms_qryWorkGroupForPagesList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryWorkGroupForPagesList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 分页查询个性化生产组明细
      wms_qryWorkGroupItemForPagesList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryWorkGroupItemForPagesList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 分页查询储区列表
      queryZoneListForPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryZoneListForPage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 分页查询耗材管理
      wms_master_qryConsumableitemForPagesList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryConsumableitemForPagesList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 新增耗材
      wms_masterservice_addConsumableitem: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addConsumableitem","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除耗材
      wms_masterservice_deleteConsumableitem: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteConsumableitem","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询仓库基本信息
      wms_masterservice_getWarehouse: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getWarehouse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 修改仓库基本信息
      wms_masterservice_updateWarehouse: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateWarehouse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 获取用户信息
      wms_masterservice_getUsers: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getUsers","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 货主能力配置
      wms_masterservice_updateOwnerBusinessTag: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateOwnerBusinessTag","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 保存日志
      wms_masterservice_addLog: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addLog","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      //发FOP  拉取商品
      wms_mamasterservice_notifyToSendDownGoodsInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"notifyToSendDownGoodsInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询客户列表（商家列表）
      wms_masterservice_queryCustomerList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCustomerList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商家下的货主列表
      wms_masterservice_queryOwnersByCustomerCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryOwnersByCustomerCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询客户商品等级列表
      wms_masterservice_queryOwnerProductLevelListByOwnerNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryOwnerProductLevelListByOwnerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询关键节点
      wms_ability_queryFirstLevelAbilityTree: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_ability_queryFirstLevelAbilityTree","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 查询黄金流程
      wms_ability_queryAbilityTreeByParentCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_ability_queryAbilityTreeByParentCode","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //查询流程列表
      wms_model_queryModelMByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_queryModelMByPage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //查询流程树
      wms_ability_queryAbilityTree: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_ability_queryAbilityTree","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 保存模型
      wms_model_saveModel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_saveModel","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 修改模型
      wms_model_editModel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_editModel","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 根据模型id查询
      wms_model_queryModeByModelId: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_queryModeByModelId","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除模型
      wms_model_removeModel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_removeModel","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 修改模型状态
      wms_model_editModelStatus: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_model_editModelStatus","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 分页查询序列号规则
      wms_master_getSkuSndestList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getSkuSndestList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //货权转移-获取任务下已有的货主
      getTaskOwner: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"getTaskOwner","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //货权转移-获取操作人
      getDoWorkerOrder: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"getDoWorkerOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  货权转移-获取分配任务
      getTaskForPage: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"getTaskForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  货权转移-获取任务明细
      getOrderDetailList: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"getOrderDetailList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  货权转移-自动定位
      repointLocate: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"repointLocate","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      //  货权转移-任务分配
      assignChangeOrderTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"assignChangeOrderTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 货权转移-取消
      receiveCancelChangeMessage: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"receiveCancelChangeMessage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保任务生成
      wms_createTsRM: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"createTsRM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 单个维保任务查询
      wms_queryTsRM: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRM","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保列表-查询
      wms_queryTsRMList: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRMListForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_queryIbRMListForPage: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"queryIbRMListForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保列表页-查看
      wms_queryTsRMDRDetail: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRMDRDetailForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保结果录入-明细
      wms_queryTsRMDetail: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRMDetailForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保操作明细展示接口
      wms_queryTsRMRDDetail: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRMRDDetailForPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保结果录入
      wms_saveTsRMResult: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"saveTsRMResult","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保-发货
      wms_rmShip: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"rmShip","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保-取消发货
      wms_rmShipCancel: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"rmShipCancel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保-关单
      wms_closeRm: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"closeRm","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
       // 维保-打印维保面签
      wms_print_rmLabel: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_print_rmLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保上传信息保存
      uploadTsRmFile: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"uploadTsRmFile","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 维保上传信息保存
      queryTsRmFileByTaskNo: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryTsRmFileByTaskNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      //循环盘点-查询分配人
      getEmployeeInfo: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"getEmployeeInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },

      // 一般补货规则配置
      wms_replenishment_saveOrUpdateReplenishmentRule: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_replenishment_saveOrUpdateReplenishmentRule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_replenishment_qryReplenishmentRuleByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_replenishment_qryReplenishmentRuleByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_replenishment_softDelReplenishmentRule: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_replenishment_softDelReplenishmentRule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

      // 根据LPN码查询
      wms_receiving_getLpnPrintParam: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_getLpnPrintParam","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 扫码 pre-complete
      sc_pre_complete: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_preComplete","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 查询货主 下拉接口
      wms_get_owner_selector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getOwnerSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 模糊查询承运商产品
      getCarrierProductSelector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getCarrierProductSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 模糊查询客户
      getCustomerSelector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getCustomerSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 号段序列号校验
      validateSectionSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"validateSectionSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 模糊查询耗材
      getConsumableSelector: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getConsumableSelector","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 新增月台
      addDock: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addDock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 更新月台
      updateDock: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateDock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除月台
      deleteDock: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteDock","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
       // 查询月台信息
      queryDockListByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDockListByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
       // 查询月台下拉数据
      queryDockByQuery: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryDockByQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryDockByQuerySchedule: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"queryDockByQuerySchedule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 更新补货任务
      urgentReplenishment: {
        uri: serviceUri.locationService,
        arg0: '{"bizType":"urgentReplenishment","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 补打面单-通用箱单 Packinglist
      queryCommonPackageDetail: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryCommonPackageDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 补打-导出箱单excel前置校验
      exportExcelPreCheck: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"exportExcelPreCheck","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 补打-分货单
      queryDistributionList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryDistributionList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 补打面单
      getPackageDByOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPackageDByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      //包裹列表
      queryPackageMByOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPackageMByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 补打面单
      queryUnScoreRule: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryUnScoreRule","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询耗材库存异常接口
      queryConsStockException: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryConsStockException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 导出耗材库存异常接口
      queryConsStockExceptionExport: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryConsStockException","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 关闭耗材库存异常接口
      closeConsStockException: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"closeConsStockException","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询 一键退供
      getOrdersInfoByOutboundNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getOrdersInfoByOutboundNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询 一键退供
      addCheckResultForManualLocate: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"addCheckResultForManualLocate","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryFrontReport: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryFrontReport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wms_co_putaway_dispatcher_query: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_dispatcher_query","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_dispatcher_detail_query: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_dispatcher_detail_query","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getNoticeToAssignSwitch: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"noticeToAssignSwitch","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      getExistPickTaskNeedAssign: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"existPickTaskNeedAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_turn2OrdinaryTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_turn2OrdinaryTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_turn2Robot: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_turn2Robot","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_turn2Picking: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_turn2Picking","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_co_putaway_assignTask: {
        uri: serviceUri.putawayService,
        arg0: '{"bizType":"wms_co_putaway_assignTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // ifop控单量指标
      queryTop5ScheduleOwner: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryTop5Schedule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 调用fop释放控单
      callFopReleaseOrder: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"callFopReleaseOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 查询 订单基础数据
      getObShipmentAllData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getObShipmentAllData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      //获取托盘码信息
      getQueryPalletInfoByPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryPalletInfoByPrint","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      //获取vas信息
      queryVasDetailListInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryVasDetailListInfo","uuid":"1","callCode": "360BUY.WMS3.WS.CALLCODE.1"}'
      },
      //子不语临时箱唛补打
      queryZBYTempBoxLabelForPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryZBYTempBoxLabelForPrint","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 查询 按批次号+批属性值查询批次信息
      getSkuLotInfoByLotAttrValue: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getSkuLotInfoByLotAttrValue","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 校验 按包装批次扫描是否合规
      checkPackageBatchNumber: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkPackageBatchNumber","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取sscc前置打印参数
      getPreprintSsccParam: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPreprintSsccParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取石头科技sscc标签参数
      getPrintSkuSsccParam: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPrintSkuSsccParam","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // /***********************************拣货任务管理 开始************************************** */
      // 查询任务信息集合
      queryWmsObGetTaskMList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getTaskMList","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryWmsDynamicTaskMList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_queryAllDynamicTasks","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 查询已完成任务信息集合
      getTaskMList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getTaskMList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },

      queryAllDynamicOrders: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_queryAllDynamicOrders","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryDynamicOrderDetail: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_queryDynamicOrderDetail","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      issuedPickingTasksByOrders: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_issuedPickingTasksByOrders","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },


      dispatchPickingTask: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_convertDynamicTasksToStaticTasks","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryStaticTaskDetail: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_queryStaticTaskDetail","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      getPackagePDFList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getPackagePDFList","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      getTaskLocateDLabelDispatch: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"getTaskLocateDLabelDispatch","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 查询任务单明细
      queryWmsObGetTaskDList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getTaskLocateDList","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 标签-获取包裹面单打印数据
      queryWmsObGetPrintFaceSheetByTaskNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getPrintFaceSheetByTaskNo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 标签-订单维度重新打单
      queryWmsObGetPrintFaceSheetByOutboundNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getPrintFaceSheetByOutboundNo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 纸单-获取包裹面单打印数据
      queryWmsObPaperPrintListByTaskNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getPaperPrintList","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryWmsObPaperPrintListByTaskListNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getTaskLocateDLabel","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 更新任务主档打印状态
      queryWmsObUpdateTaskMByPrintFlag: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_updateTaskMByPrintFlag","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 打印面单更新尾程运单号
      queryWmsObUpdateTaskDByShipNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_updateTaskDByShipNo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      queryWmsObGetPrintNonFaceSheetByTaskNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getPrintNonFaceSheetByTaskNo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 任务管理指派月台信息
      queryWmsObUpdateDock: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_updateDock","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wmsObUpdatePickingOperator: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_updatePickingOperator","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      wmsBatchUpdatePickingOperator: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_batchUpdatePickingOperator","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // /***********************************拣货任务管理 结束************************************** */
      // /***********************************集合单管理 开始************************************** */
      // 查询任务信息集合
      queryWmsObGetBatchMList: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getBatchMList","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 查询任务信息集合
      cancelPickingBatchM: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"batchCancelPickingBatchM","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // /***********************************集合单管理 结束************************************** */
      // /***********************************纸单拣货管理 开始************************************** */
      // 查询任务信息集合
      getTaskDetailsByTaskPageNo: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_getTaskDetailsByTaskPageNo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 确认带拣货下架
      listPickingDownByGood: {
        uri: serviceUri.pickingService,
        arg0: '{"bizType":"wms_ob_listPickingDownByGood","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 导入商品托盘信息
      wms_master_importPalletInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"importPalletInfo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 批量查询商品托盘信息
      wms_master_batchQueryPalletAttr: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchQueryPalletAttr","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 批量校验序列号规则
      wms_masterservice_batchCheckSerialIsRight: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchCheckSerialIsRight","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 批量校验序列号出库标识
      wms_masterservice_getItemBaseByUniqueCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getItemBaseByUniqueCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_masterservice_querySerialList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

       // 推荐耗材信息查询
      wms_queryRecommendConsumables: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryRecommendConsumables","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },

       // 批量导入序列号
      wms_master_importSerial: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"importSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },

       // 查询商品大类
      queryCatalogListByGoodsNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCatalogListByGoodsNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 绑定rebin墙
      bindRebinWallApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanAndOccupyWallNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // rebin路由接口
      routeRebinWallApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"routeRebinByContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
       // rebin大波次扫描容器号
       scanRebinContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanPickingContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 删除rebin墙
      releaseRebinWallApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"releaseRebinWall","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 记录rebin明细
      recordRebinDetailApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"recordRebinDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 订单rebin完成
      checkByOutboundApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"checkByOutbound","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 订单差异确认完成
      diffCheckByOutboundNoApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"diffCheckByOutboundNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // rebin关闭容器
      closeBigWaveByWallApi: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"closeBigWaveByWall","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      /* 货权转移-手动定位-开始*/
      //查询订单商品明细
      // getOrderDetailList:serviceParams.transferOfStoskService("getOrderDetailList"),
      //查询商品库存
      queryStockInfoForLocate:serviceParams.transferOfStoskService("queryStockInfoForLocate"),
      //预占接口
      saveLockHandLocateResult:serviceParams.transferOfStoskService("saveLockHandLocateResult"),
      //清空预占接口
      saveUnlockHandLocateResult:serviceParams.transferOfStoskService("saveUnlockHandLocateResult"),
      //整单确认
      wholeOrderConfirm:serviceParams.transferOfStoskService("wholeOrderConfirm"),
      //查询商品定位明细
      getHandLocateResult:serviceParams.transferOfStoskService("getHandLocateResult"),
      /* 货权转移-手动定位-结束*/
      //定位异常-更新补货任务
      updateReplenishment:serviceParams.locationService('updateReplenishment'),
      //货权转移-明细批量查询
      getOwnerChangeGoodsList:serviceParams.transferOfStoskService("getOwnerChangeGoodsList"),
      // 批量交接 - 商品明细
      queryPackageHandoverGoodsDetailByBatchNo:serviceParams.shipmentService("queryPackageHandoverGoodsDetailByBatchNo"),
      // 批量交接 - 商品明细(EN)
      printPackageHandoverGoodsDetail:serviceParams.shipmentService("printPackageHandoverGoodsDetail"),
      //分选复核门店打包一体化-获取包裹的信息
      checkOutboundNos:serviceParams.shipmentService('checkOutboundNos'),
      // 分选复核门店打包 门店包裹补打
      queryStorePackageRepackInfo:serviceParams.shipmentService('queryStorePackageRepackInfo'),

      //分选复核门店打包一体化-获取包裹的信息
      queryStorePackageInfo:serviceParams.shipmentService('queryStorePackageInfo'),

      //更新图片
      updatePalletFile:serviceParams.masterService("updatePalletFile"),
      //导入打托标准
      importPalletInfoV2:serviceParams.masterService("importPalletInfoV2"),
      //提总定位
      batchLocateInfoAndStockLocation:serviceParams.locationService("batchLocateInfoAndStockLocation"),
      //提总定位辅助分析
      batchLocateAssistedAnalysis:serviceParams.locationService("batchLocateAssistedAnalysis"),
      //提总定位成功明细
      queryBatchLocateSuccessInfos:serviceParams.locationService("queryBatchLocateSuccessInfos"),
      //提总定位失败明细
      queryBatchLocateFailedInfos:serviceParams.locationService("queryBatchLocateFailedInfos"),
      //取消提总定位
      batchLocateCancel:serviceParams.locationService("batchLocateCancel"),
      //确认并生成拣货任务
      batchLocateConfirmTaskAssign:serviceParams.locationService("batchLocateConfirmTaskAssign"),
      //根据集合单号下载爆品复核拼单PDF文件
      getPackagePDFByBatchNo:serviceParams.shipmentService('getPackagePDFByBatchNo'),
      //红制作图片
      queryGoodsPictureList:serviceParams.masterService('queryGoodsPictureList'),
      //Trafilea打印逆向面单
      queryShipmentLabel:serviceParams.shipmentService('queryShipmentLabel'),
      //随货文件
      queryFollowGoodsFiles:serviceParams.shipmentService('queryFollowGoodsFiles'),
      // 绑定栈板
      bindPalletForNonCustomerOrder:serviceParams.shipmentService('bindPalletForNonCustomerOrder'),

      //托规格采集
      collectPalletSpecifications:serviceParams.shipmentService("collectPalletSpecifications"),
      //托盘号生成
      generateBillNumber:serviceParams.shipmentService("generateBillNumber"),
      //满托
      addPalletInfo:serviceParams.shipmentService("addPalletInfo"),
      //新满托接口
      addPalletInfoNew:serviceParams.shipmentService("addPalletInfoNewVersion"),
      //查询打托标准
      getPalletInfoList:serviceParams.masterService("getPalletInfoList"),

      // 新增业务数据导入
      insertWmsbusinessVolume:serviceParams.shipmentService('insertWmsbusinessVolume'),
      // 修改业务数据导入
      updateWmsbusinessVolume:serviceParams.shipmentService('updateWmsbusinessVolume'),
      // 删除业务数据导入
      deleteWmsBusinessVolumeList:serviceParams.shipmentService('deleteWmsBusinessVolumeList'),
       // 查询业务数据导入
      queryWmsBusinessVolumeList:serviceParams.shipmentService('queryWmsBusinessVolumeList'),
      // 批量删除
      batchDeleteBusinessVolume:serviceParams.shipmentService('batchDeleteBusinessVolume'),
      // 查询批次号
      getLotNoByStock: serviceParams.stockService("lotService_batchQuery"),
      // 搬仓-创建搬仓单
      createMovePlanOrder:serviceParams.waveService('createMovePlanOrder'),
      // 搬仓-查询库存信息
      queryMovePlanStockInfo:serviceParams.waveService('queryMovePlanStockInfo'),
      // 搬仓-查询有搬仓计划的所有货主信息
      queryMovePlanOwners:serviceParams.waveService('queryMovePlanOwners'),
      // 搬仓-根据订单号查询搬仓计划信息
      queryMovePlanByOutboundNo:serviceParams.waveService('queryMovePlanByOutboundNo'),
      // 根据仓号查询搬仓计划和货主信息的接口
      queryMovePlanOwnerByWarehouseNo:serviceParams.waveService('queryMovePlanOwnerByWarehouseNo'),
      // 取消搬仓
      wmsCancelMoveOrder:serviceParams.locationService('cancelMoveOrder'),
      // call单异常管理
      // 查询可以重新call单的包裹信息
      getRecallPackageList:serviceParams.shipmentService('getRecallPackageList'),
      // 组装call单参数
      recallFaceSheet:serviceParams.shipmentService('recallFaceSheet'),
      // call单成功回调
      callSuccessCallBack:serviceParams.shipmentService('callSuccessCallBack'),

      // /***********************************仓容 开始************************************** */
      // 新增商品堆叠信息
      wms_masterservice_insertItemBaseStack: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"insertItemBaseStack","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商品堆叠信息
      wms_masterservice_queryItemBaseShelfDTO: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryItemBaseShelfDTO","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 修改商品堆叠信息
      wms_masterservice_updateItemBaseStack: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateItemBaseStack","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除商品堆叠信息
      wms_masterservice_deleteItemBaseStack: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteItemBaseStack","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 新增商品货架信息-填充率
      wms_masterservice_insertItemBaseShelfSpec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"insertItemBaseShelfSpec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 查询商品货架信息-填充率
      wms_masterservice_queryItemBaseShelfSpecList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryItemBaseShelfSpecList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 修改商品货架信息-填充率
      wms_masterservice_updateItemBaseShelfSpec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateItemBaseShelfSpec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 删除商品货架信息-填充率
      wms_masterservice_deleteItemBaseShelfSpec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteItemBaseShelfSpec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 插入商品货架信息-填充率（批量），保留接口，目前应该用不到，新增堆叠信息的时候就新增了填充率
      wms_masterservice_batchInsertShelfSpec: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchInsertShelfSpec","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // sku导出查询：
      queryItemBaseAttrCustomizeByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryItemBaseAttrCustomizeByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      qryUsersByTaskTypeNo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryUsersByTaskTypeNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getCacheValue: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getCacheValue","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      removeCacheValue: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"removeCacheValue","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 复核序列号记录
      saveCheckSerialData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"saveCheckSerialData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量复核序列号记录
      batchSaveCheckSerialData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchSaveCheckSerialData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 删除复核序列号记录
      removeCheckSerialData: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"removeCheckSerialData","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      createBsLogisticsPropertyTask: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"createBsLogisticsPropertyTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryCapacityByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCapacityConfigByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addCapacity: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addCapacityConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      modifyCapacity: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifyCapacityConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteCapacity: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteCapacityConfig","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      getPalletPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPalletPackage","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 绑定发货容器
      bindShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"bindShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 满发货容器并且绑定
      fullAndBindShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"fullAndBindShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 绑定发货容器
      fullShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"fullShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 扫描发货容器
      scanShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"scanShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量容器交接查询
      queryHandoverPackageInShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryHandoverPackageInShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 批量容器交接提交
      batchHandoverPackageInShippingContainer: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchHandoverPackageInShippingContainer","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      getOrderInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getOrderInfo","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      updateTmpOutbound: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateTmpOutbound","uuid":"uuid","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryCarrierProductGroupListByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCarrierProductGroupListByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      enableDisableCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"enableDisableCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      querySingleCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySingleCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      createCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"createCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryCarrierProductListByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryCarrierProductListByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      modifyCarrierProductGroup: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"modifyCarrierProductGroup","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      fillSubSerialBySnBatch: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchImportSubSerials","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // /***********************************仓容 结束************************************** */
      //根据集合单号获取订单号
      getOrderNoByBatchNo:serviceParams.shipmentService("getOrderNoByBatchNo"),
      validatePackagingRules:serviceParams.shipmentService("validatePackagingRules"),
      // 云打印自绘模板版本管理
      insertItemBaseStackCloudPrint:serviceParams.shipmentService("insertItemBaseStack"),
      updateCloudPrintConfig:serviceParams.shipmentService("updateCloudPrintConfig"),
      queryCloudPrintConfigList:serviceParams.shipmentService("queryCloudPrintConfigList"),
      deleteCloudPrintConfig:serviceParams.shipmentService("deleteCloudPrintConfig"),
      checkSerialLotNo:serviceParams.shipmentService("checkSerialLotNo"),
      queryShipmentLotSummary:serviceParams.shipmentService("queryShipmentLotSummary"),

      // 主数据
      querySerialGoodsBySerial:serviceParams.masterService('querySerialGoodsBySerial'),
      // 爆品升级 记录订单状态接口
      recordObWaybillPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"recordObWaybillPrint","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 爆品升级 集合单纬度提交复核
      addCheckResultForExplosive: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"addCheckResultForExplosive","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 爆品升级  打印爆品清单
      printExplosiveList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printExplosiveList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 出库管理 明细查询
      getPackOperationDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pagePackageOperationDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 出库管理 任务单列表
      getPackTaskList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPackTaskList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 出库管理 异常报表
      getPackExceptionList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPackTaskExceptionDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 出库管理 任务单详情页
      getPackTaskDetails: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pagePackDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // rebin 任务单列表
      getRebinTaskList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageQueryCheckTaskM","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // rebin 二级详情页
      getRebinSubpageDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageQueryCheckTaskMDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // rebin 明细页
      getRebinTaskDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageQueryCheckOperationDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // rebin 异常页
      getRebinExcepion: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageRebinExcepion","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 拣选SU picking 任务单列表
      getPickingTaskList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPickingTaskList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 拣选SU picking 二级详情页
      getPickingSubpageDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPickingTaskDetailList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 拣选SU picking 明细页
      getPickingTaskDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPickingOperateDetailList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 拣选SU picking 异常页
      getPickingExcepion: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryPickingExceptionList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 尾程预分拣su 任务单列表
      getSortingTaskList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageSortingTaskList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 尾程预分拣su 作业明细页
      getSortingTaskDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageSortingOperationDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 尾程预分拣su 二级详情页
      getSortingSubpageDetail: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"sortingTaskDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 尾程预分拣su 异常页
      getSortingExcepion: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"pageSortingExceptionDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 出库管理 明细导出
      exportPackDetails: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"exportPackageOperationDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 出库管理 异常导出
      exportPackException: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"exportPackTaskExceptionDetail","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 出库管理 任务单导出
      exportPackTaskList: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"exportPackTaskList","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 包裹交接打印标签
      queryBigPackagePrintLabelByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryBigPackagePrintLabelByBatchNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 透明计划码&FNsku打印
      queryFnSkuInfoForPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryFnSkuInfoForPrint","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 打印fab物流交接单
      queryFBADeliveryNoteByBatchNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryFBADeliveryNoteByBatchNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // su管理通用导出
      exportSuListCommon: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"export","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 托唛-TCL
      queryTCLPalletInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"queryTCLPalletInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 交接单-TCL
      printHandoverInfoOfServiceBillCode: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printHandoverInfoOfServiceBillCode","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 签收单-TCL
      printProofOfDeliveryOfServiceBillCode: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printProofOfDeliveryOfServiceBillCode","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取沙特起网打印参数
      getLabelsForSelfCloudPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getLabelsForSelfCloudPrint","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 获取adr打印参数
      getPrintAdrFileInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getPrintAdrFileInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 头程报表-获取收货列表
      firstLegGetList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_receive_order","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取收货列表
      firstLegGetDetailList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_receive_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取发货列表
      firstLegGetSendList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_send_order","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取发货明细列表
      firstLegGetSendDetailList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_send_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取查验列表
      firstLegGetCheckList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_check_order","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取查验明细列表
      firstLegGetCheckDetailList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"wms_tc_report_check_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-获取卸货列表
      firstLegGetUnloadList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"flexibleReportQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 头程报表-任务挂起
      taskPend: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_task_center_pend","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 头程报表-取消任务挂起
      cancelTaskPend: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_task_center_pend_cancel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 头程报表-手动分配任务
      taskPick: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"wms_task_center_pick_get","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //分页查询作业区
      queryWorkspaceByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryWorkspaceByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //新增作业区
      addWorkspace: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addWorkspace","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //修改作业区
      modifyWorkspace: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateWorkspace","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //启用禁用作业区
      enableDisableWorkspace: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"enableDisableWorkspace","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //删除作业区
      deleteWorkspace: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteWorkspace","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 库存操作（批量解锁库存）
      freezeStockimport: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_freezeStockimport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 库存操作（批量解锁库存）
      unfreezeStockImport: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_unfreezeStockImport","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 批量取消盘点单
      wms_checkstock_batchCancelCheckOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_batchCancelCheckOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 批量转移盘点单
      wms_checkstock_batchTransCheckOrder: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_batchTransCheckOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 批量转移盘点单
      wms_checkstock_getCheckOrdersExt: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getCheckOrdersExt","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      /******************************SAAS接口 结束***********************************/
      //差异明细
      getDiffDetail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_wsCsDiff_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryDistinctPackingRemark: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryDistinctPackingRemark","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      querySortingFlowName: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"querySortingFlowName","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryZoneCode: {
        uri: serviceUri.pickingplanService,
        arg0: '{"bizType":"queryZoneCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryExportByCondition: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryExportByCondition","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      qryBarcodeList: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"qryBarcodeList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 小黄人任务分配
      minionTaskAssign: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"minions_assignTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 小黄人任务分配
      minionQueryTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"minions_queryTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryZoneRef: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryZoneRef","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 小黄人任务分配
      minionsFinishWaveTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"minions_finishWaveTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库下架明细分页查询
      move_down_detail_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_down_detail_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库上架明细分页查询
      move_up_detail_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_up_detail_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库下架异常分页查询
      move_down_exception_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_down_exception_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库上架异常分页查询
      move_up_exception_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_up_exception_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库下架任务分页查询接口
      move_down_task_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_down_task_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库上架任务分页查询接口
      move_up_task_page: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_up_task_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库下架任务详情查询
      move_down_task_detail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_down_task_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 移库上架任务详情查询
      move_up_task_detail: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_up_task_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 盘点明细列表
      wms_checkstock_su_detailPage: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_su_detailPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 盘点异常列表
      wms_checkstock_su_diff_detailPage: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_su_diff_detailPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 盘点详情列表
      wms_checkstock_getSuCheckTasksByCsOrderId: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"wms_checkstock_getSuCheckTasksByCsOrderId","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // // 任务指派
      // move_up_task_assign: {
      //   uri: serviceUri.checkstockService,
      //   arg0: '{"bizType":"move_up_exception_page","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      // },
      // 移库数据查询
      queryMovePickingTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"queryMovePickingTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 生成移库任务
      saveMovePickingTask: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"saveMovePickingTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 上架指派
      moveUpTaskAssign: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"moveUpTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 下架指派
      moveDownTaskAssign: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"moveDownTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      batchDeleteContainer: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"batchDeleteContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryRebinWallDetail: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryRebinWallDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateRebinWallContainer: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateRebinWallContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryContainerSpecificationByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerSpcByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryContainerSpecification: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerSpcList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      insertContainerSpecification: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"insertContainerSpc","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      updateContainerSpecification: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"updateContainerSpc","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      deleteContainerSpecification: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"deleteContainerSpc","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryContainerByPageV2: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerByPageV2","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryRebinWallByPage: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryRebinWallByPage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryContainerCodeSegment: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerCodeSegment","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      insertMultiContainerV2: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"insertMultiContainerV2","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryOwnerProductLevel: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryOwnerProductLevel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryMosGoodsInfoList: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"queryMosGoodsInfoList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 任务分配/自动组波货主查询
      getObShipmentList4OwnerNo: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getObShipmentList4OwnerNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 任务分配/自动组波尾程查询
      getObShipmentList4CarrierNo: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"getObShipmentList4CarrierNo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      // 全量交接
      wms_receiving_parcel_finishJoinAll: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_finishJoinAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryPrintContainerCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryPrintContainerCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryWarehouse: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryWarehouse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 子不语重置包裹
      deletePackageByPackageNo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"deletePackageByPackageNo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
    
      // 打单平台新打单接口
      printDocAll: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printDocAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      moveDownTaskDelete: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"move_down_task_delete","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 打印面单接口(非JDW)
      getLabels: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getLabels","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 打印面单接口(JDW)
      getLabelsForJDW: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getLabelsForJDW","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 正逆一体专用
      batchGetLabelsForJDW: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"batchGetLabelsForJDW","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      queryContainerDistribution: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerCount","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryEquipmentCode: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryEquipmentCode","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      addConsumablesLocation: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"addConsumablesLocation","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      //检查barcode唯一性 （子不语需求加的）
      receivingQueryScanSku: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_queryScanSku","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 小鹏-订单维度packingList
      xPengPackingListByOrder: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"xPengPackingListByOrder","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 小鹏-托维度packingList
      xPengPackingListByPallet: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"xPengPackingListByPallet","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 小鹏-包裹维度packingList
      xPengPackingListByPackage: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"xPengPackingListByPackage","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 小鹏-DA-订单维度
      rePrintOrderDAInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"rePrintOrderDAInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 小鹏-CI-订单维度
      rePrintOrderCIInfo: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"rePrintOrderCIInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 换标查询接口
      replaceSSCCLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"replaceSSCCLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 托换标
      replacePalletSSCCLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"replacePalletSSCCLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 更新包裹换标完成接口
      updateReplaceSSCCLabelSuccess: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateReplaceSSCCLabelSuccess","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 更新拖换标完成接口
      updateReplacePalletSSCCLabelSuccess: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"updateReplacePalletSSCCLabelSuccess","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      querySerialRuleBySku: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"querySerialRuleBySku","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      checkIfMatchTargetSerialRule: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkIfMatchTargetSerialRule","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 打单平台
      printPlatformPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printPlatformPrint","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 老打印接口直连打印中心
      globalPrint: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"globalPrint","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // 打印危险标签
      printDangerousLabel: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"printDangerousLabel","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      // po标签打印
      getAddressByTrackingNumber: {
        uri: serviceUri.shipmentService,
        arg0: '{"bizType":"getAddressByTrackingNumber","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.1"}'
      },
      wms_inbound_tc_su_send_taskDetailList: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_tc_su_send_taskDetailList","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_tc_check_reportTaskDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_tc_check_reportTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },      
      wms_receiving_query_detail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_query_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_tc_putaway_getPutawayTaskDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_tc_putaway_getPutawayTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_tc_su_send_backSendTask: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_tc_su_send_backSendTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_tc_su_send_clickContainerLoading: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_tc_su_send_clickContainerLoading","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 根据容器号，获取容器信息
      getContainerDto: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"getContainerDto","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryUserLogin: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryUserLogin","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_su_check_reportTaskDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_su_check_reportTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      }, 
      wms_receiving_query_detail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_query_detail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      }, 
      wms_su_putaway_getPutawayTaskDetail: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_su_putaway_getPutawayTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      }, 
      scanBarcodeGetGoodsInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanBarcodeGetGoodsInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      checkIfMatchTargetSerialRuleAndExistedBatch4Reverse: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"checkIfMatchTargetSerialRuleAndExistedBatch4Reverse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_asn_ex_query: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_asn_ex_query","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 收货关联异常容器/调拨异常单查询
      wms_receiving_asnEx_queryRelatedContainers: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_asnEx_queryRelatedContainers","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 调拨异常单商品计划/已收数量（仅用于展示）
      wms_receiving_queryExAsnTaskDetailQty: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_queryExAsnTaskDetailQty","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_asn_ex_export: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_asn_ex_export","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_asn_ex_close: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_asn_ex_close","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      scanBarcodeGetGoodsInfo: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"scanBarcodeGetGoodsInfo","uuid":"","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      checkIfMatchTargetSerialRuleAndExistedBatch4Reverse: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkIfMatchTargetSerialRuleAndExistedBatch4Reverse","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      queryAssistant: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryAssistant","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      bindAssistant: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"bindAssistant","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      unbindAssistant: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"unbindAssistant","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      flexibleReportQuery: {
        uri: serviceUri.smartqueryService,
        arg0: '{"bizType":"flexibleReportQuery","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.10401"}'
      },
      checkBindAssistant: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"checkBindAssistant","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      wms_receiving_receivingTask_getIbReverseReceivingTask: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_getIbReverseReceivingTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      receiving_query_serialPackageLotValue: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"receiving_query_serialPackageLotValue","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_parcel_finishReverseJoinAll: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_parcel_finishReverseJoinAll","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },      
      wms_receiving_ibReceivingService_completeReverseAsnForNonBook: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ibReceivingService_completeReverseAsnForNonBook","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryContainerTransferTaskDetail: {
        uri: serviceUri.masterService,
        arg0: '{"bizType":"queryContainerTransferTaskDetail","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.9999"}'
      },
      // 判断扫描的skulist是否属于该单
      skuJudgeByOrder:{
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_rfid_executeScanSKU","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_inbound_receiving2_validateReverseSerial: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_inbound_receiving2_validateReverseSerial","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_receivingTask_getOverGoodsTaskD: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_receivingTask_getOverGoodsTaskD","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_ex_d_query: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ex_d_query","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_ex_d_export: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ex_d_export","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_receiving_ex_d_submit: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_ex_d_submit","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      // 判断扫描的skulist是否属于该单
      skuJudgeByOrder:{
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_receiving_rfid_executeScanSKU","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      inventoryCycle_reassignCCWkno: {
        uri: serviceUri.checkstockService,
        arg0: '{"bizType":"inventoryCycle_reassignCCWkno","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      wms_asn_ex_re_commit: {
        uri: serviceUri.receivingService,
        arg0: '{"bizType":"wms_asn_ex_re_commit","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      /*****
       * *************************SAAS接口 结束***********************************/
      // 增值服务
      obtainProcessTaskByContainer: {
        uri: serviceUri.invopSuService,
        arg0: '{"bizType":"W0701#obtainProcessTaskByContainer","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      processTask: {
        uri: serviceUri.invopSuService,
        arg0: '{"bizType":"W0701#processTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      competeTask: {
        uri: serviceUri.invopSuService,
        arg0: '{"bizType":"W0701#competeTask","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      queryPrintVasInfo: {
        uri: serviceUri.queryPrintVasInfo,
        arg0: '{"bizType":"W0701#vas_ws_queryPrintVasInfo","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
      moveDownTaskAssign: {
        uri: serviceUri.transferOfStoskService,
        arg0: '{"bizType":"moveDownTaskAssign","uuid":"1","callCode":"360BUY.WMS3.WS.CALLCODE.100"}'
      },
    }
    // getBizType:function(bizTypeName){
    //     return this.bizTypeMap[bizTypeName].trim();
    // }wms_co_putaway_getExContainerInfo

  }
  // window.bizTypeMap = service.bizTypeMap;
  return service
}
let service = createBizTypeMapping()
export const
  getUrl = (bizType) => {
    return service.getBizTypeUrl(bizType)
  }
export const
  packageData = (bizType, data) => {
    return service.packageData(bizType, data)
  }
export const bizTypeMap = service.bizTypeMap
